import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Switch, Route } from "react-router-dom";
import Corporate from "pages/sales/createLead/corporate/index";
import Apartments from "pages/sales/createLead/apartments/index";
import PreSalesListing from "pages/sales/preSalesListing";
import PostSalesListing from "pages/sales/postSalesListing";
import followUp from "pages/sales/followUp";
import ViewPocs from "pages/sales/viewPocs";
import PreSalesSupply from "pages/sales/preSalesSupply/index";
import Supply from "pages/sales/createLead/supply";
import AddPoc from "pages/sales/addPoc";
import AddGate from "pages/sales/gates";
import CreditPolicy from "pages/CreditPolicy";
import EmployeeCreditPolicy from "pages/EmployeeCreditPolicy";
import B2bAlliance from "pages/sales/preSales/b2bAlliance";
import PostB2bAlliance from "pages/sales/postSales/b2bAlliance";
import PostSalesSupply from "pages/sales/postSales/supply";
import PostSalesApartment from "pages/sales/postSales/apartment";
import B2bAlliances from "pages/sales/createLead/b2bAlliances";
import PostSalesCorporate from "pages/sales/postSales/corporate";
import contractCorporate from "pages/sales/postSales/contractCorporate";
import ContractApt from "pages/sales/postSales/contractApt";
import CreateFollowUp from "pages/sales/createFollowUp/copResdenFollowUp";
import SupplyFollowUp from "pages/sales/createFollowUp/supplyFollowUp";
import B2BAlliancesFollowUp from "pages/sales/createFollowUp/b2BAlliancesFollowUp";
import ApprovalList from "pages/sales/approvals";
import LeadApproval from "pages/sales/leadApproval";
import InspectionApprovals from "pages/sales/inspectionApprovals";
import InspectionDetails from "pages/sales/inspectionDetails";
import ViewDetails from "pages/sales/preSales/presalesDetail";
import ViewFollowUp from "pages/sales/viewFollowUp";
import ViewLead from "pages/sales/postSales/viewLead";
import ContractLead from "pages/sales/postSales/contractLead";
import ChangeAssignee from "pages/sales/changeAssignee";
import SiteListing from "pages/installation/siteListing";
import TaskListing from "pages/installation/taskListing";
import SiteLog from "pages/installation/siteLog";
import Meetings from "pages/installation/meetings";
import ScheduleMeeting from "pages/installation/meetings/scheduleMeeting";
import SiteStages from "pages/installation/siteStages";
import ValidateLocation from "pages/installation/validateLocation";
import SetTargetDate from "pages/installation/setTargetDate";
import MeetingDetail from "pages/installation/meetings/meetingDetail";
import SiteInspection from "pages/installation/siteInspection";
import SiteInspectionMaterial from "pages/installation/siteInspectionMaterial";
import EditCorporate from "pages/sales/editLead/corporate";
import EditApartments from "pages/sales/editLead/apartments";
import EditSupply from "pages/sales/editLead/supply";
import EditB2bAlliances from "pages/sales/editLead/b2bAlliances";
import EditAptContract from "pages/sales/editContract/apartment";
import AddInvoiceNum from "pages/sales/editContract/addInvoice";
import ToolkitInspection from "pages/ToolkitInspection/toolkitInspection";
import ToolkitInspectionForm from "pages/ToolkitInspection/toolkitInspectionForm";
import ToolkitInspectionView from "pages/ToolkitInspection/toolkitInspectionView";

import EditCorpContract from "pages/sales/editContract/corporate";
import EditSupplyContract from "pages/sales/editContract/supply";
import SiteAssignee from "pages/installation/siteAssignee";
import InventoryChecklist from "pages/installation/inventoryCheckList";
import SiteInfoCheckList from "pages/installation/siteInfoCheckList";
import VendorAllocation from "pages/installation/vendorAllocation";
import TicketsListing from "pages/tickets/ticketsListing";
import TicketDetails from "pages/tickets/ticketDetails";
import ManageVendor from "pages/installation/vendorAllocation/manageVendor";
import CivilCheckout from "pages/installation/civilChecklist";
import HardwareInstall from "pages/installation/hardwareInstall";
import CreateTicket from "pages/tickets/createTicket";
import HandOver from "pages/installation/handOver";
import checkoutDetails from "pages/attendance/checkoutDetails";
import AttendanceDetails from "pages/attendance/attendanceDetails";
import DarwinCheckInOut from "pages/attendance/darwinCheckInOut";
import LocationApprovalsList from "pages/approvals/locationApprovalsList";
import SiteAbortApprovalsList from "pages/approvals/siteAbortApprovalsList";
import MaterialRequisition from "pages/installation/materialRequisition/index";
import SiteEngineerList from "pages/installation/siteEngineerList";
import SiteEngineerDetails from "pages/installation/siteEngineerDetails";
import MrfApprovalsList from "pages/approvals/mrfApprovalsList";
import MaterialDelivery from "pages/installation/materialDelivery";
import TagDelivery from "pages/installation/tagDelivery";
import InspectionRequests from "pages/maintenance/inspectionRequests";
import InspectionForm from "pages/maintenance/inspectionForm";
import InspectionFormMail from "pages/maintenance/inspectionFormMail";
import InspectionCreated from "pages/maintenance/inspectionCreated";
import Notfound from "pages/notfound";
import GoLiveSites from "pages/maintenance/goLiveSites";
import CreatePmList from "pages/maintenance/pmList";
import PmCheckList from "pages/maintenance/pmCheckList";
import SitesLocationMap from "pages/sitesLocationMap";
import PmSities from "pages/maintenance/pmSities";
import PmSitiesDashboard from "pages/maintenance/pmDashboard";
import PmSitesCheckList from "pages/maintenance/pmSitesCheckList";
import PmChecklistQues from "pages/maintenance/pmChecklistQues";
import FileComplain from "pages/fileComplain";
import CreateComplain from "pages/fileComplain/createComplain";
import EmpTicketsListing from "pages/employeeTickets/empTicketsListing";
import EmpCreateTicket from "pages/employeeTickets/empCreateTicket";
import ViewComplainList from "pages/fileComplain/viewComplainList";
import ViewComplain from "pages/fileComplain/viewComplain";
import PmTickets from "pages/maintenance/pmTicket";
import PMTicketDetails from "pages/maintenance/ticketDetails";
import PmAssignTicket from "pages/maintenance/pmAssignTicket";
import ManagePM from "pages/maintenance/managePM";
import ApprovalPmSites from "pages/maintenance/approvalPmSites";
import ApprovalPmTicket from "pages/maintenance/approvalPmTicket";
import RmTickets from "pages/maintenance/rmList";
import RmTicketsReport from "pages/maintenance/rmListReport";
import ViewRmTicket from "pages/maintenance/viewRmTicket";
import RmLog from "pages/maintenance/rmLog";
import ComplaintLog from "pages/maintenance/complaintLog";
import ClosedRmTicket from "pages/maintenance/closedRMTicket";
import ViewRmTicketReport from "pages/maintenance/viewRmTicketReport";
import EmployeeTicketList from "pages/maintenance/employeeTicketList";
import RMTicketDetails from "pages/maintenance/ticketDetails";
import ViewEmployeeTicket from "pages/maintenance/viewEmployeeTicket";
import EmTicketAssign from "pages/maintenance/emAssignTicket";
import RmAssignTicket from "pages/maintenance/rmAssignTicket";
import ApprovalRmTickets from "pages/maintenance/approvalRmTickets/index";
import ViewReportPmSites from "pages/maintenance/viewReportPmSites";
import Mrf from "pages/maintenance/mrf";
import Troubleshoot from "pages/fileComplain/troubleshoot";
import ApprovalEmTicketList from "pages/maintenance/approvalEmTicket";
import BrandActivation from "pages/brandActivation/sitesListing";
import BaViewPocs from "pages/brandActivation/viewPocs";
import BaAddPoc from "pages/brandActivation/addPoc";
import ViewSitedetails from "pages/brandActivation/viewSitedetails";
import ScheduledMeetings from "pages/brandActivation/meetings";
import MeetingTracker from "pages/brandActivation/meetingTracker";
import CreateMom from "pages/brandActivation/meetingTracker/createMinutesOfMeet";
import ViewMom from "pages/brandActivation/meetingTracker/viewMinutesOfMeet";
import ScheduleNewMeeting from "pages/brandActivation/meetingTracker/scheduleAMeeting";
import ScheduleAMeeting from "pages/brandActivation/meetings/scheduleAMeeting";
import MeetingDetails from "pages/brandActivation/meetings/meetingDetail";
import BAMeetingDetail from "pages/brandActivation/meetingTracker/meetingDetail";
import MinutesOfMeeting from "pages/brandActivation/meetings/minutesOfMeeting";
import ViewMomDetails from "pages/brandActivation/meetings/viewMomDetails";
import ProductsList from "pages/brandActivation/products";
import ProductDetails from "pages/brandActivation/productDetails";
import KnowledgeCenter from "pages/brandActivation/knowledgeCenter";
import Checkout from "pages/brandActivation/checkout";
import ConductCamp from "pages/brandActivation/conductCamp";
import ScheduleCamp from "pages/brandActivation/conductCamp/scheduleCamp";
import CampDetails from "pages/brandActivation/conductCamp/campDetail";
import CampMinutesOfMeeting from "pages/brandActivation/conductCamp/minutesOfMeeting";
import CampViewMomDetails from "pages/brandActivation/conductCamp/viewMomDetails";
import CampVendorAllocation from "pages/brandActivation/conductCamp/vendorAllocation";
import CorporateList from "pages/brandActivation/corporateList";
import AddCorporateClient from "pages/brandActivation/addCorporateClient";
import CorpClientPoc from "pages/brandActivation/pocList";
import InvoiceList from "pages/brandActivation/invoice";
import InvoiceViewDetails from "pages/brandActivation/invoice/viewDetail";
import ManageAddPoc from "pages/brandActivation/manageAddPoc";
import PreCamp from "pages/brandActivation/conductCamp/preCamp";
import PostCamp from "pages/brandActivation/conductCamp/postCamp";
import MakePayment from "pages/brandActivation/invoice/makePayment";
import ApprovedSalesListing from "pages/sales/approvedSalesListing";
import SalesTargetsListing from "pages/sales/salesTargetsListing";
import FinanceContractList from "pages/sales/financeContract";
import SiteDashboard from "pages/sales/siteDashboard";
import SiteDetailView from "pages/sales/siteDashboard/siteDetailIndex";
import BusinessListing from "pages/sales/businessListing";
import PaymentRequest from "pages/sales/paymentRequest";
import PerformaInvoiceListing from "pages/sales/performaInvoiceListing";
import TaxInvoiceListing from "pages/sales/taxInvoiceListing";
import ContractSalesListing from "pages/sales/contractListing";
import ApprovalCampListing from "pages/brandActivation/conductCamp/approvalCampListing";
import BaChangeAssignee from "pages/brandActivation/changeAssignee";
import Profile from "pages/profile";
import MrfEdit from "pages/installation/editMrf";
import GoLiveChangeAssignee from "pages/maintenance/goLiveChangeAssignee";
import ConductCarnival from "pages/brandActivation/conductCarnival";
import ConductSiteCarnival from "pages/brandActivation/conductSiteCarnival";
import AddCarnival from "pages/brandActivation/conductCarnival/addCarnival";
import UpdateCarnival from "pages/brandActivation/conductCarnival/updateCarnival";
import DuplicateCarnival from "pages/brandActivation/conductCarnival/duplicateCarnival";
import CarnivalDetails from "pages/brandActivation/conductCarnival/carnivalDetail";
import FdTicketsListing from "pages/brandActivation/freshdeskTickets";
import Scanner from "pages/brandActivation/scanner";
import CreateFdTicket from "pages/brandActivation/freshdeskTickets/createTicket";
import ViewTicket from "pages/brandActivation/freshdeskTickets/viewTicket";
import Feedback from "pages/brandActivation/feedback";
import FeedbackDetails from "pages/brandActivation/feedback/feedbackDetail";
import VendorRequestList from "pages/vendorPortal/vendorListing";
import VendorOnboardedListing from "pages/vendorPortal/vendorOnboardedListing";
import VendorPaymentList from "pages/vendorPortal/vendorPaymentList";
import VendorPayment from "pages/vendorPortal/vendorPayment";
import VendorRequest from "pages/vendorPortal/vendorRequest";
import PaymentInvoiceRequestDetails from "pages/vendorPortal/paymentInvoiceRequestDetails";
import VendorPaymentDetails from "pages/vendorPortal/vendorPaymentDetails";
import VendorPaymentRequest from "pages/vendorPortal/vendorPaymentRequest";
import VendorPaymentRequestList from "pages/vendorPortal/vendorPaymentRequestList";
import VendorPaymentRequestDetails from "pages/vendorPortal/vendorPaymentRequestDetails";
import VendorPaymentRequestApproval from "pages/vendorPortal/vendorPaymentRequestApproval";
import VendorPaymentRequestApprovalPage from "pages/vendorPortal/vendorPaymentRequestApprovalPage";
import VendorPaymentRequestApprovalList from "pages/vendorPortal/vendorPaymentRequestApprovalList";

import ViewSiteInspectionChecklist from "pages/installation/viewChecklist/siteInspectionChecklist";
import SiteLeadReferralList from "pages/valetServices/siteLeadReferral";
import ClientClientReferralList from "pages/valetServices/clientClientReferral";
import ValetReferralForm from "pages/valetServices/valetReferral";
import DeviceDelink from "pages/valetServices/deviceDelink";
import SupervisorList from "pages/valetServices/SupervisorList";
import ValetList from "pages/valetServices/ValetList";
import Supervisor from "../../../valetServices/Supervisor";
import Valet from "../../../valetServices/Valet/";
import InfraZone from "../../../valetServices/InfraZone/";
import Projects from "../../../valetServices/Projects";
import IncentiveSlab from "../../../valetServices/IncentiveSlab";
import NormalOnboarding from "../../../brandActivation/conductCarnival/addNormal";
import ListingNormal from "../../../brandActivation/conductCarnival/NormalOnboarding";
import UpdateNormalOnboarding from "../../../brandActivation/conductCarnival/UpdateNormalOnboarding";
import PmSiteApprovals from "../../../approvals/PmSiteApproval";
import ProjectOnboarding from "pages/sales/projectOnboarding";
import OnboardProject from "pages/sales/projectOnboarding/onboardProject";
import AddQuotation from "pages/sales/quotation/addQuotation";
import ViewQuotations from "pages/sales/quotation/viewQuotations";
import ViewApproveQuotations from "pages/sales/quotation/approveQuotation/viewQuotations";
import ApproveQuotations from "pages/sales/quotation/approveQuotation/approveQuotations";
import ViewQuotation from "pages/sales/quotation/viewQuotations/viewQuotation";
import EditQuotation from "pages/sales/quotation/editQuotation";
import QuotationHistory from "pages/sales/quotation/quotationHistory";

import AssignmentForm from "../../../BulkAssignment/BrandActivity";
import ZoneListing from "../../../valetServices/InfraZoneListing";
import EditProject from "pages/sales/editLead/onboarding";
import ViewDetailForApproval from "pages/sales/preSales/viewDetailForApproval";
import SiteRepository from "../../../installation/siteListing/SiteRepository";
import EnggTasksDetails from "pages/installation/engineerTasks";
import EngineerTasksForm from "pages/installation/engineerTasksForm";
import SiteIncentive from "pages/sales/siteIncentive";
import AddIncentive from "pages/sales/addSiteIncentive";
import UserIncentiveLists from "pages/sales/incentiveLists";
import SeniorIncentiveLists from "pages/sales/incentiveSeniorLists";
import FinanceIncentive from "pages/sales/financeIncentiveList";
import HeadIncentiveLists from "pages/sales/incentiveHeadLists";
import RenewContract from "pages/brandActivation/contractRenewal";
import RenewApprovals from "pages/sales/renewApprovals";
import RenewalListing from "pages/brandActivation/renewalListing";
import CreateMrf from "../../../MaterialRequistionForm/Store";
import MrfListing from "../../../MaterialRequistionForm/Listing";
import ViewListing from "../../../MaterialRequistionForm/ViewListing";
import ApprovalListing from "../../../MaterialRequistionForm/ApprovalListing";
import SiteRepositoryFinance from "../../../installation/siteListing/SiteRepositoryFinance";
import EditContractRenewal from "pages/brandActivation/editContractRenewal";
import RmView from "pages/maintenance/rmView";
import SiteIncentiveListing from "pages/sales/siteIncentiveListing";
import HoldApprovalForm from "pages/vendorPortal/holdApproveForm";
import LoginSso from "pages/auth/loginSso";
import CreditLimitLedger from "../../../MaterialRequistionForm/CreditLimitLedger";
import HelpdeskListing from "../../../brandActivation/conductCarnival/helpdeskListing";
import AddHelpdesk from "pages/brandActivation/conductCarnival/addHelpdesk";
import HelpdeskDetails from "../../../brandActivation/conductCarnival/helpdeskDetail";
import UpdateHelpdesk from "../../../brandActivation/conductCarnival/updateHelpdesk";
import DuplicateHelpdesk from "../../../brandActivation/conductCarnival/duplicateHelpdesk";
import UpdateRMTicket from "pages/maintenance/updateRMTicket";
import UnclaimedTransactionListing from "pages/brandActivation/unclaimedTransaction";
import EditComplain from "pages/fileComplain/editComplain";
import taxInvoiceLobListing from "pages/sales/taxInvoiceLobListing";
import FirstInteraction from "pages/installation/firstInteraction";
import ConfigurationAndTesting from "pages/installation/configurationTesting";
import Transaction from "../../../Wallet/Listing";
import AddAmount from "../../../Wallet/AddToInternal";
import WalletListing from "../../../Wallet/WalletListing/Internal";
import WalletApprovalListing from "../../../Wallet/TransactionList";
import WalletApproval from "pages/Wallet/WalletApproval";
import AddToExternal from "pages/Wallet/AddToExternal";
import TagApprovals from "pages/sales/tagApprovals";
import TagMismatchDetails from "pages/sales/tagMismatchDetails";
import ViewClaim from "../../../brandActivation/viewClaim";
import HotoSiteListing from "../../../maintenance/hotoSiteListing";
import HotoChangeAsignee from "../../../maintenance/hotoChangeAssignee";
import HotoSiteEngineerListing from "../../../maintenance/hotoSiteEngineerListing";
import HotoMainForm from "../../../maintenance/hotoMainForm";
import HotoApproval from "../../../maintenance/hotoApproval";
import HotoInstallForm from "../../../maintenance/hotoInstallForm";
import EmpToEmpListing from "../../../MaterialRequistionForm/EmpToEmpListing";
import EmpFullfillmentForm from "../../../MaterialRequistionForm/EmpFullfillmentForm";
import financeBusinenessList from "pages/sales/financeBusinenessList";
import financeAddBusiness from "pages/sales/financeAddBusiness";
import AddLocationDetails from "pages/sales/addLocation";
import AddClientLocation from "pages/sales/addClientLocation";
import clientListing from "pages/sales/clientListing";
import AddClient from "pages/sales/addClient";
import clientBusiness from "pages/sales/clientBusiness";
import BusinessChange from "pages/sales/businessChange";
import ClientChange from "pages/sales/clientChange";
import MaterialReceiving from "../../../installation/materialReceiving";
import MaterialReceiveForm from "../../../installation/materialReceiveForm";
import UpdatePoc from "../../../brandActivation/updatePoc";
import ProjectConfiguration from "pages/projectConfiguration";
import SiteEngineerTasksForm from "pages/installation/siteEngineerTasksForm";
import SiteListsForEngineer from "pages/installation/siteListsForEngineer";
import ViewDailyTaskDetails from "pages/installation/viewDailyTaskDetails";
import TagSearch from "pages/tagSearch";
import IncreaseCreditLimit from "../../../MaterialRequistionForm/UserCreditLimit/IncreaseCreditLimit";
import UserCreditLimit from "../../../MaterialRequistionForm/UserCreditLimit/List";
import ListTag from "../../../valetServices/Tags/List";
import SaveTag from "../../../valetServices/Tags/Save";
import ChequePicked from "pages/brandActivation/meetingTracker/chequePicked";
import SiteAssetMapping from "pages/installation/siteAssetMapping";
import SiteGates from "pages/installation/siteGates";
import AssetMapping from "pages/installation/assetMapping";
import AssetMappingInfo from "pages/installation/assetMappingInfo";
import ContractAssets from "pages/installation/contractAssets";
import NewSiteAssetMapping from "pages/installation/newSiteAssetMapping";
import ContractListing from "../../../AssetsMappingContract/ContractList";
import ContractGates from "../../../AssetsMappingContract/GateListing";
import MaterialAction from "../../../AssetsMappingContract/Material";
import VendorPaymentModification from "pages/vendorPortal/vendorPaymentModification";
import ReturnTag from "pages/returnTag";
import ClientMapping from "pages/sales/clientMapping";
import ExternalWalletListing from "../../../Wallet/WalletListing/External";
import ViewRequest from "../../../Wallet/View";
import FirstInteractionFIRForm from "components/installation/firForms";
import CorporateMallForm from "components/installation/corporateMallFirstInteractionForm";
import SiteMaintenance from "pages/brandActivation/siteMaintenanceUser";
import MaintenanceChangeAssignee from "pages/brandActivation/maintenanceChangeAssignee";
import BABusinessListing from "../../../brandActivation/Business";
import ViewHelper from "../../../HelperDetails/ViewHelper";
import AddHelper from "../../../HelperDetails/AddHelper";
import SiteVisit from "../../../installation/SiteVisit";
import SiteVisitList from "../../../installation/SiteVisit/Listing";
import SiteAbortApprovalsListFinance from "pages/approvals/siteAbortApprovalsListFinance";
import Dashboard from "../../../brandActivation/baDashboard";
import AddressListing from "pages/sales/addressListing";
import businessAddressListing from "pages/sales/businessAddressListing";
import SiteVisitDetails from "../../../installation/SiteVisit/View";
import AssesmentResources from "pages/Assesment/AssesmentResources";
import Training from "pages/Assesment/Training";
import TakeTest from "pages/Assesment/TakeTest";
import AssesmentHistory from "pages/Assesment/AssesmentHistory";
import MasterAssesmentHistory from "pages/Assesment/MasterAssesmentHistory";

import RequestListing from "pages/Wallet/RequestList";
import RequestView from "pages/Wallet/RequestListView";
import RequestTransactionDetails from "pages/Wallet/RequestTransactionList";
import RequestInternal from "pages/Wallet/RequestInternal";
import RequestExternal from "pages/Wallet/RequestExternal";
import WalletRequestList from "pages/Wallet/WalletRequestListing";
import ApprovalWalletDetails from "pages/Wallet/ApprovalWalletDetails";
import ViewComplainListSupport from "pages/fileComplain/viewComplainListSupport";
import ViewComplainSupportTeam from "pages/fileComplain/viewComplainSupportTeam";
import DealerWalletListing from "../../../Wallet/WalletListing/Dealer";
import AddToDealerWallet from "pages/Wallet/AddToDealerWallet";
import DealerWalletListingApproval from "pages/Wallet/WalletDealerApproval/Dealer";
import DealerFinance from "pages/Wallet/WalletDealerApproval/DealerFinance";

import UserHelpdeskListing from "components/HelpdeskUsers/helpdeskListing";
import ConfigHelpdesk from "components/HelpdeskUsers/configHelpdesk/";
import EditConfig from "components/HelpdeskUsers/editConfig";
import UserRequest from "../../../../components/HelpdeskUsers/UserRequest";
import Listing from "../../../../components/HelpdeskUsers/UserRequestList";
import PendingList from "../../../../components/HelpdeskUsers/ManagerApprovalPendingList";
import PendingListingFinance from "../../../../components/HelpdeskUsers/Finance/FinnaceApprovedPending";
import UserRequestView from "../../../../components/HelpdeskUsers/View";
import ApprovedAndRejectedList from "../../../../components/HelpdeskUsers/Finance/ApprovedAndRejectedList";
import ManagerApprovalRejectedList from "../../../../components/HelpdeskUsers/ManagerApprovalRejectedList";
import ScannerTest from "pages/installation/scannerTest";
import businessListingAll from "pages/sales/businessListingAll";
import ViewDetailsBusiness from "pages/sales/preSales/presalesDetailBusiness";
import AddLocationDetailsAll from "pages/sales/addLocationAll";
import ClientListingAll from "pages/sales/clientListingAll";
import AddClientLocationAll from "pages/sales/addClientLocationAll";
import PmSoftwareChecklist from "../../../maintenance/PmSoftwareChecklist";
import PmSoftwareSities from "../../../maintenance/PmSoftwareChecklist/ScheduleList";
import ChangeAssingee from "../../../maintenance/PmSoftwareChecklist/ChangeAssignee";
import ViewReportPmSoftwareSites from "../../../maintenance/PmSoftwareChecklist/ViewReport";
import PmSoftwarePendingSities from "../../../maintenance/PmSoftwareChecklist/ApprovedList";
import LedgerListing from "pages/sales/ledgerListing";
import InvoiceValidationList from "../../InvoiceValidation/List";
import PosShipment from "pages/installation/posShipment";
import Tutorial from "pages/Assesment/Tutorial";
import TutorialListing from "pages/Assesment/TutorialListing";
import UserConfigListing from "components/UserConfig/configListing";
import AddConfig from "components/UserConfig/addConfig";
import EditUserConfig from "components/UserConfig/editConfig";
import GoLiveValet from "pages/installation/goLiveValet";
import PlanSchedule from "pages/brandActivation/meetings/planSchedule";
import PlanScheduleList from "pages/brandActivation/Plan";
import SchedulePlanMeeting from "pages/brandActivation/meetingTracker/schedulePlanMeeting";
import SoftwareRmTickets from "pages/maintenance/softwareRmTicket";
import HardwareRmTickets from "pages/maintenance/hardwareRmTicket";
import FileMeetingPlanUpload from "pages/brandActivation/fileMeetingPlanUpload";
import SiteListingMaintenance from "pages/maintenance/siteListingMaintenance";
import ServicePrLisitng from "pages/servicePr";
import ServicePrApprovalsList from "pages/servicePrApprovals";
import PrConfirmation from "pages/prConfirmation";
import PrConfirmationDetails from "pages/prConfirmation/prConfirmationDetails";
import PublicSiteForPosChangesListing from "../../../installation/PosReplaceAndReturnSites/Listing";
import PosReplacement from "pages/installation/posReplacement";
import PosReturn from "pages/installation/posReturn";
import VariableInvoice from "../../postSales/ValetInvoice/Variable";
import FixedList from "../../postSales/ValetInvoice/Fixed";
import EditVariable from "../../postSales/ValetInvoice/Edit/Variable";
import ValetServiceApprovalList from "../../postSales/ValetInvoice/ApprovalList";
import ApprovalValetInvoiceLineItems from "../../postSales/ValetInvoice/View";
import ViewFixed from "../../postSales/ValetInvoice/Fixed/View";
import HierarchyListing from "../../../../components/HelpdeskUsers/Finance/HierarchyListing";
import ValetIncentive from "components/ValetIncentive";
import ValetUserList from "components/ValetUserList";
import ValetTransactionList from "components/ValetTransactionList";
import SaveAsDraft from "pages/brandActivation/meetingTracker/saveAsDraft";
import CheckIn from "pages/brandActivation/meetingTracker/checkIn";
import RefundRequest from "components/cxDashboard/refundRequests";
import OrderDetails from "components/cxDashboard/orderDetails";
import CarnivalConduct from "pages/installation/carnivalConduct";
import DashboardTraining from "pages/installation/dashboardTraining";
import CarnivalDetailsBa from "pages/installation/carnivalDetailsBa";
import AddCarnivalThroughStage from "pages/brandActivation/conductCarnival/addCarnivalThroughStage";
import TrainingChecklist from "components/installation/trainingChecklist";
import ChangeMaintenanceSlot from "pages/maintenance/changeMaintenanceSlot";
import ManagePMSlot from "pages/maintenance/managePMSlot";
import RefundView from "../../../../components/cxDashboard/refundRequests/View";
import EmployeePosMapping from "pages/installation/employeePosMapping";
import DealerAllSites from "pages/Wallet/WalletDealerApproval/DealerAllSites";
import CampaignListing from "pages/AdsCampaign/CampaignListing";
import CampaignCreation from "pages/AdsCampaign/CampaignCreation";
import ManagerPendingList from "pages/AdsCampaign/ManagerPendingList";
import L2PendingList from "pages/AdsCampaign/L2PendingList";
import FinanceListing from "pages/AdsCampaign/FinanceListing";
import CampaignView from "pages/AdsCampaign/CampaignView";
import ValetSalary from "pages/valetServices/ValetSalary";
import MonthlyValetSalary from "pages/valetServices/MonthlyValetSalary";
import SalaryMaster from "pages/valetServices/SalaryMaster";
import ValetChatList from "pages/valetServices/ValetChatList";
import AbscondDriverList from "pages/valetServices/AbscondDriverList";
import ValetChartListView from "pages/valetServices/ValetChartListView";
import RcTransferList from "pages/RcTransfer/RcTransferList";
import RcTransferView from "pages/RcTransfer/RcTransferView";
import contractCorporateNew from "pages/sales/postSales/contractCorporateNew";
import DismantleMrf from "../../../installation/siteListing/Mrf";
import ViewDismantleMrf from "../../../installation/siteListing/MrfView";
import FinanceMrfListing from "pages/sales/financeMrfListing";
import MrfFinanceView from "pages/sales/MrfFinanceView";
import BackToModificationRequest from "../../../../components/HelpdeskUsers/SBFM";
import CompressImage from "pages/CompressImage";
import FinanceApprovalListing from "pages/approvals/approvalListing";
import AllValetList from "components/AllValetList";
import AllSupervisorList from "components/AllSupervisorList";
import UpdateValetDetails from "components/UpdateValetDetails";
import UpdateSupervisorListing from "components/UpdateSupervisorListing";
import UsersRating from "pages/brandActivation/BaRating/UsersRating";
import UserView from "pages/brandActivation/BaRating/UserView";
import MeetingRating from "pages/brandActivation/BaRating/MeetingRating";
import MeetingView from "pages/brandActivation/BaRating/MeetingView";
import ScoreByHod from "pages/brandActivation/BaRating/SelfScorecard/ScoreByHod";
import ScoreBySenior from "pages/brandActivation/BaRating/SelfScorecard/ScoreBySenior";
import ServiceInvoiceList from "pages/sales/postSales/ServiceInvoice/ServiceInvoiceList";
import EditServiceInvoice from "pages/sales/postSales/ServiceInvoice/EditServiceInvoice";
import FixedServiceInvoiceList from "pages/sales/postSales/ServiceInvoice/FixedServiceInvoiceList";
import ApprovalServiceInvoiceLineItems from "pages/sales/postSales/ServiceInvoice/View";
import SalaryPromotion from "components/SalaryPromotion";
import SuperVisorSalaryPromotion from "../../../../components/SupervisorSalaryPromotion";
import supervisorSalaryPromotion from "../../../../components/SupervisorSalaryPromotion";

// import UpdateInstallationDate from "pages/installation/siteListing/UpdateInstallationDate/";
import RaiseUpdateInstallationDate from "pages/installation/siteListing/UpdateInstallationDate";
import UCDListing from "../../../CarLoan/DealerListing";
import DealerView from "../../../CarLoan/DealerListing/DealerView";
import SaveDealerCase from "../../../CarLoan/DealerListing/Cases/Save";
import CaseListing from "../../../CarLoan/DealerListing/Cases/Listing";
import CaseView from "../../../CarLoan/DealerListing/Cases/View";
import PaymentUcdCaseInvoice from "../../../CarLoan/DealerListing/Cases/vendorPayment";
import PostponeInstallationApprovalsList from "pages/approvals/postponeInstallationApprovalsList";
import ViewPostponeInstallationDetails from "pages/approvals/postponeInstallationApprovalsList/viewDetails";
import InstallationRequestListing from "pages/installation/siteListing/UpdateInstallationDate/InstallationRequestListing";
import RaiseIssue from "pages/fileComplain/RaiseIssue";
import ViewIssue from "pages/fileComplain/ViewIssue";
import UCDCasesEdit from "../../../CarLoan/DealerListing/Cases/Edit";
import InternalCommunication from "pages/valetServices/InternalCommunincation";
import NcsMeetingList from "pages/brandActivation/meetingTracker/ncsMeetingList";
import NcsMeetingComplete from "pages/brandActivation/meetingTracker/ncsMeetingComplete";
import NcsMeetingView from "pages/brandActivation/meetingTracker/ncsMeetingView";
import PaymentRaise from "../../../CarLoan/DealerListing/Cases/PaymentRaise";
import PaymentDetails from "../../../CarLoan/DealerListing/Cases/PaymentDetails";
import pennyDropAccount from "../../../CarLoan/DealerListing/Cases/PennyDropAccount";
import PendingPaymentForRelease from "../../../CarLoan/DealerListing/Cases/PendingPaymentForRelease";
import ApprovalCase from "../../../CarLoan/DealerListing/Cases/ApprovalCase";
import ApprovedCase from "../../../CarLoan/DealerListing/Cases/ApprovedCase";
import BankSheetUpload from "pages/CarLoan/DealerListing/Cases/BankSheetUpload";
import PayoutDetails from "pages/CarLoan/DealerListing/Cases/PayoutDetails";
import PayoutDetailsForBusinessHead from "pages/CarLoan/DealerListing/Cases/PayoutDetailsForBusinessHead";
import BusinessHeadList from "pages/CarLoan/DealerListing/Cases/BusinessHeadList";
import PayoutReleaseList from "pages/CarLoan/DealerListing/Cases/PayoutReleaseList";
import FinanceHeadPayoutAccept from "pages/CarLoan/DealerListing/Cases/FinanceHeadPayoutAccept";
import FinanceDirectorList from "pages/CarLoan/DealerListing/Cases/FinanceDirectorList";
import FinanceDirectorAction from "pages/CarLoan/DealerListing/Cases/FinanceDirectorAction";
import ContractExpiryList from "pages/ContractRenewal/ContractExpiryList";
import RaiseRenewalRequest from "pages/ContractRenewal/RaiseRenewalRequest";
import RenewalRequestList from "pages/ContractRenewal/RenewalRequestList";
import RenewalRequestDetails from "pages/ContractRenewal/RenewalRequestDetails";
import ViewLeadV2 from "pages/ContractRenewal/ViewLead";
import RaisedRequestsList from "pages/ContractRenewal/RaisedRequestsList";
import TagSearchByVehicleNo from "pages/tagSearchByVehicleNo";
import UserAccessDashboard from "pages/sales/userAccessDashboard";
import EventSalary from "pages/valetServices/EventSalary";
import ExternalUserList from "pages/sales/externalUserList";
import ApprovedSalesChallan from "pages/sales/approvedSitesChallan";
import ClientOrders from "pages/brandActivation/ClientOrders";
import BankSheetList from "../../../CarLoan/DealerListing/Cases/BankSheetList";
import B2CLeadList from "../../../CarLoan/DealerListing/Cases/B2CLead";
import B2CEdit from "../../../CarLoan/DealerListing/Cases/B2CEdit";
import B2CLoggedIn from "../../../CarLoan/DealerListing/Cases/B2CLoggedIn";
import B2CPaymentRequest from "../../../CarLoan/DealerListing/Cases/B2CPaymentRequest";
import B2CPendingPaymentRelease from "../../../CarLoan/DealerListing/Cases/B2CPendingPaymentRelease";
import PaymentRaiseV2 from "../../../CarLoan/DealerListing/Cases/paymentRaiseV2";
import TranchesReleaseRequest from "../../../CarLoan/DealerListing/Cases/LoanTranchesReleaseRequest";
import VendorPaymentAdvance from "pages/vendorPortal/vendorPaymentAdvance";
import InvoiceRequestList from "pages/vendorPortal/invoiceRequestList";
import PerformanceTracker from "pages/sales/performanceTracker";
import PmProjectSitesCheckList from "pages/maintenance/pmProjectSitesCheckList";
import PmProjects from "pages/maintenance/pmProjects";
import ManageProjectPMSlot from "pages/maintenance/manageProjectPMSlot";
import manageProjectPM from "pages/maintenance/manageProjectPM";
import B2CEditWithoutDealer from "../../../CarLoan/DealerListing/Cases/B2CCaseWithoutLead";
import ComplaintForCentralTech from "../../../fileComplain/CentralTech/ComplaintRaise";
import TechComplainList from "../../../fileComplain/CentralTech/List";
import CentralTechViewIssue from "../../../fileComplain/CentralTech/ViewIssue";
import SalesOrderReturn from "pages/MaterialRequistionForm/SalesOrderReturn";
import RTOCaseView from "../../../CarLoan/DealerListing/Cases/RTO/View";
import RTOB2CLoggedIn from "../../../CarLoan/DealerListing/Cases/RTO/RTOB2CLoggedIn";
import RTOB2B from "../../../CarLoan/DealerListing/Cases/RTO/RTOB2B";
import RtoDocuments from "../../../CarLoan/DealerListing/Cases/RTO/Documents";
import RequiredDocuments from "pages/installation/RequiredDocuments";
import ViewUploadedDocuments from "pages/installation/ViewUploadedDocuments";
import SiteConsumes from "pages/installation/siteConsumes";
import contractCorporateEdit from "pages/sales/postSales/contractCorporateEdit";
import RTOCasesList from "../../../CarLoan/DealerListing/Cases/RTO/CaseList";
import RTOCaseSave from "../../../CarLoan/DealerListing/Cases/RTO/SaveCase";
import MasterSalaryPenalty from "../../../valetServices/SuggestPenalty";
import Penalty from "../../../valetServices/SuggestPenalty";
import CommissionPayoutCasesList from "pages/CarLoan/DealerListing/Cases/CommissionPayoutCasesList";
import CompetitionMapping from "components/brandActivation/CompetitionMapping";
import CompetitionMappingList from "components/brandActivation/CompetitionMappingList";
import ApproveRejectList from "pages/OffroleEmployees/ApproveRejectList";
import EmployeeRequest from "pages/OffroleEmployees/EmployeeRequest";
import GenerateLink from "pages/OffroleEmployees/GenerateLink";
import UpdateRequest from "pages/OffroleEmployees/UpdateRequest";
import ActiveReactivateList from "pages/OffroleEmployees/ActiveReactivateList";
import ActiveInactive from "pages/OffroleEmployees/ActiveInactive";
import AttendanceRequestList from "components/AttendanceRequestList";
import AttendanceMasterList from "components/AttendanceMasterList";
import DarwinRecordList from "pages/darwinRecord/DarwinRecordList";
import DarwinDailyActivities from "pages/darwinRecord/DarwinDailyActivities";
import MarkRegularization from "pages/darwinRecord/MarkRegularization";
import {
  DarwinManagerRegularizationList,
  DarwinEmployeeRegularizationList,
} from "pages/darwinRecord/DarwinRegularizationList";
import DarwinRegularizationDetails from "pages/darwinRecord/DarwinRegularizationDetails";
import B2CViewDetails from "pages/CarLoan/DealerListing/Cases/B2CViewDetails";
import CapexInvoiceList from "pages/sales/postSales/ServiceInvoice/CapexInvoiceList";
import AdvanceSalary from "pages/valetServices/AdvanceSalary";
import ViewVendorDetail from "pages/vendorPortal/viewVendorDetail";
import AddVendorBankDetail from "pages/vendorPortal/addVendorBankDetail";
import VendorAddressForm from "pages/vendorPortal/vendorAddressForm";
import BrandList from "pages/BusinessItems/Brand";
import CategoryList from "pages/BusinessItems/Category";
import HsnList from "pages/BusinessItems/Hsn";
import CreateBrand from "pages/BusinessItems/CreateBrand";
import AddCategory from "pages/BusinessItems/AddCategory";
import CreateHsn from "pages/BusinessItems/CreateHsn";
import MrfTypes from "pages/MaterialRequistionForm/MrfTypes/MrfTypeList";
import CreateMrfType from "pages/MaterialRequistionForm/MrfTypes/CreateMrfType";
import MaterialList from "pages/BusinessItems/Material";
import ServiceList from "pages/BusinessItems/Service";
import CreateBusinessItem from "pages/BusinessItems/CreateBusinessItem";
import EditBusinessItem from "pages/BusinessItems/EditBusinessItem";
import ViewBusinessItem from "pages/BusinessItems/ViewBusinessItem";
import LobListing from "pages/Lob/LobListing";
import CreateLob from "pages/Lob/CreateLob";
import EditLob from "pages/Lob/EditLob";
import FasTagPricing from "pages/FasTag/FasTagPricing";
import FastagReKyV from "pages/FasTag/FastagReKyV";
import EditMrfType from "pages/MaterialRequistionForm/MrfTypes/EditMrfType";
import DynamicContentsList from "pages/dynamicContents/DynamicContentsList";
import DynamicContentsAdd from "pages/dynamicContents/DynamicContentsAdd";
import DynamicContentsEdit from "pages/dynamicContents/DynamicContentsEdit";
import DynamicContentsView from "pages/dynamicContents/DynamicContentsView";
import MarkHandover from "pages/sales/channelPartner/markHandover";
import InvoiceVisibility from "pages/sales/channelPartner/InvoiceVisibility";
import ToaTagOrders from "pages/FasTag/ToaTagOrders";
import ViewTagOrder from "pages/FasTag/ViewTagOrder";
import SubmitJMS from "pages/installation/submitJMS";
import JmsList from "pages/installation/jmsList";

const DashboardRoutes = ({
  baseUrl,
  activeComponent,
  departmentId,
  role,
  teamId,
}) => {
  const [departmentIds, setDepartmentIds] = useState(departmentId);
  const [activeComponents, setActiveComponents] = useState(activeComponent);
  useEffect(() => {
    setDepartmentIds(departmentId);
  }, [departmentId]);
  useEffect(() => {
    setActiveComponents(activeComponent);
  }, [activeComponent]);

  return (
    <Switch>
      {/* {(role.includes(67) || role.includes(12)) && ( */}
        {/* <> */}
          <Route
            exact
            path={`${baseUrl}/fastag-pricing`}
            component={FasTagPricing}
          />
          <Route
            exact
            path={`${baseUrl}/toa-tag-orders`}
            component={ToaTagOrders}
          />
          <Route
            exact
            path={`${baseUrl}/view-tag-order/:id`}
            component={ViewTagOrder}
          />
          <Route
            exact
            path={`${baseUrl}/fastag-compliance`}
            component={FastagReKyV}
          />
        {/* </> */}
      {/* )} */}

      {/* {(role.includes(69)) && (
        <> */}
          <Route
            exact
            path={`${baseUrl}/handover-transfer`}
            component={MarkHandover}
          />
          <Route
            exact
            path={`${baseUrl}/invoice-visibility`}
            component={InvoiceVisibility}
          />
        {/* </>
      )} */}
      {role.includes(4) && (
        <Route
          exact
          path={`${baseUrl}/return-tag/:id/:lead_id`}
          component={ReturnTag}
        />
      )}
      <Route
        exact
        path={`${baseUrl}/central-tech-complain`}
        component={ComplaintForCentralTech}
      />
      <Route
        exact
        path={`${baseUrl}/central-tech-view-issue/:id`}
        component={CentralTechViewIssue}
      />
      <Route
        exact
        path={`${baseUrl}/central-tech-complain-list`}
        component={TechComplainList}
      />
      <Route
        exact
        path={`${baseUrl}/user-access-dashboard`}
        component={UserAccessDashboard}
      />
      <Route
        exact
        path={`${baseUrl}/view-project-pm-list/:id/:manageId`}
        component={PmProjectSitesCheckList}
      />
      <Route exact path={`${baseUrl}/pm-projects`} component={PmProjects} />
      {/* <Route exact path={`${baseUrl}/fastag-pricing`} component={FasTagPricing} /> */}
      <Route
        exact
        path={`${baseUrl}/manage-project-pm/:id/:manageId`}
        component={manageProjectPM}
      />
      <Route
        exect
        path={`${baseUrl}/performance-tracker`}
        component={PerformanceTracker}
      />
      <Route
        exect
        path={`${baseUrl}/ncs-meetings`}
        component={NcsMeetingList}
      />
      <Route
        exect
        path={`${baseUrl}/ncs-meeting-complete/:id`}
        component={NcsMeetingComplete}
      />
      <Route
        exect
        path={`${baseUrl}/view-meeting-complete/:id`}
        component={NcsMeetingView}
      />
      <Route
        exact
        path={`${baseUrl}/public-sites`}
        component={PublicSiteForPosChangesListing}
      />
      <Route
        exact
        path={`${baseUrl}/replace-pos/:site_id/:lead_id`}
        component={PosReplacement}
      />
      <Route
        exact
        path={`${baseUrl}/return-pos/:site_id/:lead_id`}
        component={PosReturn}
      />
      {/* New stage urls */}

      <Route
        exact
        path={`${baseUrl}/lob-list`}
        component={LobListing}
      />

      <Route
        exact
        path={`${baseUrl}/add-lob`}
        component={CreateLob}
      />

      <Route
        exact
        path={`${baseUrl}/edit-lob/:id`}
        component={EditLob}
      />

      <Route exact path={`${baseUrl}/rc-transfer`} component={RcTransferList} />
      <Route
        exact
        path={`${baseUrl}/rc-transfer-view/:lead_id`}
        component={RcTransferView}
      />
      <Route
        exact
        path={`${baseUrl}/ucd/rc-case-view/:loan_id/:application_id`}
        component={RTOCaseView}
      />
      <Route
        exact
        path={`${baseUrl}/ucd/rc-b2c-case-list`}
        component={RTOB2CLoggedIn}
      />
      <Route
        exact
        path={`${baseUrl}/ucd/rc-b2b-case-list`}
        component={RTOB2B}
      />
      <Route
        exact
        path={`${baseUrl}/ucd/commission-payout-list`}
        component={CommissionPayoutCasesList}
      />
      <Route
        exact
        path={`${baseUrl}/ucd/rc-documents/:loan_id/:application_id`}
        component={RtoDocuments}
      />
      <Route exact path={`${baseUrl}/ucd/list`} component={UCDListing} />
      <Route
        exact
        path={`${baseUrl}/ucd/b2c-case-without-dealer/:id?`}
        component={B2CEditWithoutDealer}
      />
      <Route
        exact
        path={`${baseUrl}/ucd/case/save/:id?`}
        component={RTOCaseSave}
      />
      <Route exact path={`${baseUrl}/ucd/view/:id`} component={DealerView} />
      <Route
        exact
        path={`${baseUrl}/ucd/payout-details/:id`}
        component={PayoutDetails}
      />
      <Route
        exact
        path={`${baseUrl}/ucd/payout-details-for-business-head/:id`}
        component={PayoutDetailsForBusinessHead}
      />
      <Route
        exact
        path={`${baseUrl}/ucd/case-add/:loan_type/:id`}
        component={SaveDealerCase}
      />
      <Route
        exact
        path={`${baseUrl}/ucd/case-list/:dealer_id/:id`}
        component={CaseListing}
      />
      <Route
        exact
        path={`${baseUrl}/ucd/business-head-payout-list`}
        component={BusinessHeadList}
      />
      <Route
        exact
        path={`${baseUrl}/ucd/finance-head-payout-release-list`}
        component={PayoutReleaseList}
      />
      <Route
        exact
        path={`${baseUrl}/ucd/finance-director-payout-list`}
        component={FinanceDirectorList}
      />
      <Route
        exact
        path={`${baseUrl}/ucd/case/loan-tranche-release-request/:id`}
        component={TranchesReleaseRequest}
      />
      <Route
        exact
        path={`${baseUrl}/ucd/finance-director-action/:id`}
        component={FinanceDirectorAction}
      />
      <Route
        exact
        path={`${baseUrl}/ucd/finance-head-payout-accept/:id`}
        component={FinanceHeadPayoutAccept}
      />
      <Route
        exact
        path={`${baseUrl}/ucd/bank-sheet-upload`}
        component={BankSheetUpload}
      />
      <Route
        exact
        path={`${baseUrl}/ucd/bank-sheet-list`}
        component={BankSheetList}
      />
      <Route
        exact
        path={`${baseUrl}/ucd/case-edit/:ucd_dealer_id/:id`}
        component={UCDCasesEdit}
      />
      <Route exact path={`${baseUrl}/ucd/case-view/:id`} component={CaseView} />
      <Route
        exact
        path={`${baseUrl}/ucd/b2c-case-view/:id`}
        component={B2CViewDetails}
      />
      <Route
        exact
        path={`${baseUrl}/ucd/case/payment-raise/:id`}
        component={PaymentRaise}
      />
      <Route
        exact
        path={`${baseUrl}/ucd/case/payment-raise-v2/:id/:dealer_id?`}
        component={PaymentRaiseV2}
      />
      <Route
        exact
        path={`${baseUrl}/ucd/case/payment-raise-view/:id`}
        component={PaymentDetails}
      />
      <Route
        exact
        path={`${baseUrl}/ucd/case/account-penny-drop/:id`}
        component={pennyDropAccount}
      />
      <Route
        exact
        path={`${baseUrl}/ucd/pending-payment`}
        component={PendingPaymentForRelease}
      />
      <Route
        exact
        path={`${baseUrl}/ucd/b2c-pending-payment`}
        component={B2CPendingPaymentRelease}
      />
      <Route
        exact
        path={`${baseUrl}/ucd/request-payment-release`}
        component={ApprovalCase}
      />
      <Route
        exact
        path={`${baseUrl}/ucd/b2c-request-payment-release`}
        component={B2CPaymentRequest}
      />
      <Route
        exact
        path={`${baseUrl}/ucd/approved-payment`}
        component={ApprovedCase}
      />
      <Route
        exact
        path={`${baseUrl}/ucd/b2c-lead-list`}
        component={B2CLeadList}
      />
      <Route exact path={`${baseUrl}/ucd/b2c-edit/:id`} component={B2CEdit} />
      <Route
        exact
        path={`${baseUrl}/ucd/lead/logged-in`}
        component={B2CLoggedIn}
      />
      <Route
        exact
        path={`${baseUrl}/ucd/rto/cases/list`}
        component={RTOCasesList}
      />
      <Route
        exact
        path={`${baseUrl}/ucd/vendor-payment-request/:vendor_id/:lsq_dealer_id/:id`}
        component={PaymentUcdCaseInvoice}
      />
      <Route
        exact
        path={`${baseUrl}/dismantle-mrf-view/:site_id/:lead_id`}
        component={ViewDismantleMrf}
      />
      <Route
        exact
        path={`${baseUrl}/dismantle-mrf/:site_id/:lead_id`}
        component={DismantleMrf}
      />
      <Route
        exact
        path={`${baseUrl}/submit-jms/:site_id/:lead_id/:jms_id?`}
        component={SubmitJMS}
      />
      <Route
        exact
        path={`${baseUrl}/jms-list`}
        component={JmsList}
      />
      <Route
        exact
        path={`${baseUrl}/contract-listing`}
        component={FinanceContractList}
      />
      <Route
        exact
        path={`${baseUrl}/dashboard-training/:site_id/stage/:stageId/:leadId`}
        component={DashboardTraining}
      />
      <Route
        exact
        path={`${baseUrl}/image-compression`}
        component={CompressImage}
      />
      <Route
        exact
        path={`${baseUrl}/carnival/:gate/:id/stage/:stageId/:leadId`}
        component={CarnivalConduct}
      />
      <Route
        exact
        path={`${baseUrl}/carnival-details/:id/stg/:stageId/:leadId`}
        component={CarnivalDetailsBa}
      />
      <Route
        exact
        path={`${baseUrl}/add-checklist`}
        component={TrainingChecklist}
      />
      <Route
        exact
        path={`${baseUrl}/add-contract-corporate-v2/:lead_id`}
        component={contractCorporateNew}
      />
      <Route
        exact
        path={`${baseUrl}/edit-contract-corporate-v2/:comm_id/:lead_id`}
        component={contractCorporateEdit}
      />
      <Route
        exact
        path={`${baseUrl}/change-slot/:rm_ticket_id`}
        component={ChangeMaintenanceSlot}
      />
      <Route
        exact
        path={`${baseUrl}/manage-pm-slot/:id/:manageId`}
        component={ManagePMSlot}
      />
      <Route
        exact
        path={`${baseUrl}/manage-project-pm-slot/:id/:manageId`}
        component={ManageProjectPMSlot}
      />
      {/* end */}
      <Route
        exact
        path={`${baseUrl}/cx-refund-request`}
        component={RefundRequest}
      />
      <Route
        exact
        path={`${baseUrl}/cx-refund-request-view/:order_id/:id`}
        component={RefundView}
      />
      <Route
        exact
        path={`${baseUrl}/order-details/:order_id`}
        component={OrderDetails}
      />
      <Route
        exact
        path={`${baseUrl}/valet-incentive-portal/:user_id/:from_date/:to_date/:project_id`}
        component={ValetIncentive}
      />
      <Route
        exact
        path={`${baseUrl}/valet-user-listing`}
        component={ValetUserList}
      />
      <Route
        exact
        path={`${baseUrl}/all-valet-listing`}
        component={AllValetList}
      />
      <Route
        exact
        path={`${baseUrl}/attendance-request-list`}
        component={AttendanceRequestList}
      />
      <Route
        exact
        path={`${baseUrl}/attendance-master-list`}
        component={AttendanceMasterList}
      />
      <Route exact path={`${baseUrl}/darwin-record`} component={DarwinRecordList} />
      <Route
        exact
        path={`${baseUrl}/darwin-record/daily-activities`}
        component={DarwinDailyActivities}
      />
      <Route
        exact
        path={`${baseUrl}/darwin-record/regularize`}
        component={MarkRegularization}
      />
      <Route
        exact
        path={`${baseUrl}/darwin-record/regularizations/manager`}
        component={DarwinManagerRegularizationList}
      />
      <Route
        exact
        path={`${baseUrl}/darwin-record/regularizations/employee`}
        component={DarwinEmployeeRegularizationList}
      />
      <Route
        exact
        path={`${baseUrl}/darwin-record/regularizations/details`}
        component={DarwinRegularizationDetails}
      />
      <Route
        exact
        path={`${baseUrl}/all-supervisor-listing`}
        component={AllSupervisorList}
      />
      <Route
        exact
        path={`${baseUrl}/update-valet-data/:user_id`}
        component={UpdateValetDetails}
      />
      <Route
        exact
        path={`${baseUrl}/salary-promotion/:user_id`}
        component={SalaryPromotion}
      />
      <Route
        exact
        path={`${baseUrl}/supervisor-salary-promotion/:user_id`}
        component={supervisorSalaryPromotion}
      />
      <Route
        exact
        path={`${baseUrl}/update-supervisor-data/:user_id`}
        component={UpdateSupervisorListing}
      />
      <Route
        exact
        path={`${baseUrl}/last-five-transactions/:user_id`}
        component={ValetTransactionList}
      />
      <Route
        exact
        path={`${baseUrl}/pm-dashboard`}
        component={PmSitiesDashboard}
      />
      <Route
        exact
        path={`${baseUrl}/invoice-validation-list`}
        component={InvoiceValidationList}
      />
      <Route
        exact
        path={`${baseUrl}/pm-dashboard`}
        component={PmSitiesDashboard}
      />
      <Route
        exact
        path={`${baseUrl}/valet-approval-action-invoice-list/:invoice_id`}
        component={ApprovalValetInvoiceLineItems}
      />
      <Route
        exact
        path={`${baseUrl}/service-approval-action-invoice-list/:invoice_id`}
        component={ApprovalServiceInvoiceLineItems}
      />
      <Route
        exact
        path={`${baseUrl}/valet-approval-invoice-list`}
        component={ValetServiceApprovalList}
      />
      <Route
        exact
        path={`${baseUrl}/valet-fixed-invoice-view/:invoice_id`}
        component={ViewFixed}
      />
      <Route
        exact
        path={`${baseUrl}/valet-variable-invoice-edit/:invoice_id`}
        component={EditVariable}
      />
      <Route
        exact
        path={`${baseUrl}/valet-variable-invoice-list`}
        component={VariableInvoice}
      />
      <Route
        exact
        path={`${baseUrl}/variable-service-invoice-list`}
        component={ServiceInvoiceList}
      />
      <Route
        exact
        path={`${baseUrl}/service-variable-invoice-edit/:invoice_id/:installment_type`}
        component={EditServiceInvoice}
      />
      <Route
        exact
        path={`${baseUrl}/valet-fixed-invoice-list`}
        component={FixedList}
      />
      <Route
        exact
        path={`${baseUrl}/service-fixed-invoice-list`}
        component={FixedServiceInvoiceList}
      />
      <Route
        exact
        path={`${baseUrl}/invoice-validation-list`}
        component={InvoiceValidationList}
      />
      <Route
        exact
        path={`${baseUrl}/capex-invoice-list`}
        component={CapexInvoiceList}
      />
      <Route
        exact
        path={`${baseUrl}/business-lists`}
        component={businessListingAll}
      />
      <Route
        exact
        path={`${baseUrl}/view-details-business/:id`}
        component={ViewDetailsBusiness}
      />
      <Route
        exact
        strict
        path={`${baseUrl}/business-addresses/:lead_id`}
        component={businessAddressListing}
      />
      <Route
        exact
        path={`${baseUrl}/add-location-all/:type/:lead_id`}
        component={AddLocationDetailsAll}
      />
      <Route
        exact
        path={`${baseUrl}/add-client-location-all/:type/:lead_id/:client_id`}
        component={AddClientLocationAll}
      />
      <Route
        exact
        path={`${baseUrl}/view-client-address/:client_id`}
        component={AddressListing}
      />
      <Route
        exact
        path={`${baseUrl}/client-list-all`}
        component={ClientListingAll}
      />
      <Route
        exact
        path={`${baseUrl}/pm-software-checklist-ques/:id/:schedule_id`}
        component={PmSoftwareChecklist}
      />
      <Route
        exact
        path={`${baseUrl}/pm-software-sites/`}
        component={PmSoftwareSities}
      />
      <Route
        exact
        path={`${baseUrl}/pm-software-assignee-change/:id/:manageId`}
        component={ChangeAssingee}
      />
      <Route
        exact
        path={`${baseUrl}/pm-software-view-report/:id/:manageId`}
        component={ViewReportPmSoftwareSites}
      />
      <Route
        exact
        path={`${baseUrl}/approvals/pm-software-approve-report`}
        component={PmSoftwarePendingSities}
      />
      <Route
        exact
        path={`${baseUrl}/ledger-listing/:recon_business_id/:lead_id`}
        component={LedgerListing}
      />
      <Route
        exact
        path={`${baseUrl}/assesment-resources/:id/:role_id`}
        component={AssesmentResources}
      />
      <Route exact path={`${baseUrl}/training-levels`} component={Training} />
      <Route
        exact
        path={`${baseUrl}/start-level-test/:id/:role_id`}
        component={TakeTest}
      />
      <Route
        exact
        path={`${baseUrl}/assesment-history/:id/:role_id`}
        component={AssesmentHistory}
      />
      <Route
        exact
        path={`${baseUrl}/master-assesment-history`}
        component={MasterAssesmentHistory}
      />
      {/* Wallet Dashboard */}
      {/* <Route*/}
      {/*   exact*/}
      {/*   path={`${baseUrl}/wallet/transaction/:wallet_id`}*/}
      {/*   component={Transaction}*/}
      {/* />*/}
      <Route exact path={`${baseUrl}/ba-dashboard`} component={Dashboard} />
      <Route exact path={`${baseUrl}/client-orders`} component={ClientOrders} />
      <Route
        exact
        path={`${baseUrl}/tutorial-questions`}
        component={Tutorial}
      />
      <Route
        exact
        path={`${baseUrl}/tutorial-listing`}
        component={TutorialListing}
      />
      <Route exact path={`${baseUrl}/site-visit`} component={SiteVisit} />
      <Route
        exact
        path={`${baseUrl}/site-visit-list`}
        component={SiteVisitList}
      />
      <Route
        exact
        path={`${baseUrl}/site-visit-view/:id`}
        component={SiteVisitDetails}
      />
      <Route exact path={`${baseUrl}/site-visit`} component={SiteVisit} />
      <Route
        exact
        path={`${baseUrl}/site-visit-list`}
        component={SiteVisitList}
      />
      <Route
        exact
        path={`${baseUrl}/site-visit-view/:id`}
        component={SiteVisitDetails}
      />
      <Route exact path={`${baseUrl}/tag-search`} component={TagSearch} />
      <Route
        exact
        path={`${baseUrl}/tag/search-vehicle-no`}
        component={TagSearchByVehicleNo}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/add-helper/:lead_id/:id`}
        component={AddHelper}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/edit-helper/:lead_id/:id/:helper_id`}
        component={AddHelper}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/helper-list/:lead_id/:id`}
        component={ViewHelper}
      />
      <Route
        exact
        path={`${baseUrl}/ba-business-list`}
        component={BABusinessListing}
      />
      <Route
        exact
        path={`${baseUrl}/campaign-list`}
        component={CampaignListing}
      />
      <Route
        exact
        path={`${baseUrl}/campaign-creation`}
        component={CampaignCreation}
      />
      <Route
        exact
        path={`${baseUrl}/manager-pending-list`}
        component={ManagerPendingList}
      />
      <Route
        exact
        path={`${baseUrl}/l2-pending-list`}
        component={L2PendingList}
      />
      <Route
        exact
        path={`${baseUrl}/finance-list`}
        component={FinanceListing}
      />
      <Route
        exact
        path={`${baseUrl}/campaign-view/:campaign_id`}
        component={CampaignView}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/plan-schedule-list`}
        component={PlanScheduleList}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/file-meeting-upload-list`}
        component={FileMeetingPlanUpload}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/schedule-plan-meeting/:site_id/:manage_id`}
        component={SchedulePlanMeeting}
      />
      <Route
        exact
        path={`${baseUrl}/wallet/approval/:wallet_id/:sub_category?`}
        component={WalletApprovalListing}
      />
      <Route
        exact
        path={`${baseUrl}/wallet-approval-listing`}
        component={WalletApproval}
      />
      <Route
        exact
        path={`${baseUrl}/wallet-request-listing`}
        component={RequestListing}
      />
      <Route
        exact
        path={`${baseUrl}/all-wallet-request-list/:wallet_id`}
        component={WalletRequestList}
      />
      <Route
        exact
        path={`${baseUrl}/wallet/request-view/:type/:id?`}
        component={ViewRequest}
      />
      <Route
        exact
        path={`${baseUrl}/wallet/approval-wallet-details/:id`}
        component={ApprovalWalletDetails}
      />
      <Route
        exact
        path={`${baseUrl}/request-transaction-details/:id`}
        component={RequestTransactionDetails}
      />
      <Route
        exact
        path={`${baseUrl}/wallet/new-request/:is_old/:id/`}
        component={RequestView}
      />
      <Route
        exact
        path={`${baseUrl}/internal-wallet/add-amount/:wallet_id/:subcategory`}
        component={AddAmount}
      />
      <Route
        exact
        path={`${baseUrl}/external-wallet/add-amount/:wallet_id`}
        component={AddToExternal}
      />
      <Route
        exact
        path={`${baseUrl}/internal-wallet-list`}
        component={WalletListing}
      />
      <Route
        exact
        path={`${baseUrl}/external-wallet-list`}
        component={ExternalWalletListing}
      />
      <Route
        exact
        path={`${baseUrl}/dealer-wallet`}
        component={DealerWalletListing}
      />
      <Route
        exact
        path={`${baseUrl}/dm-request`}
        component={AddToDealerWallet}
      />
      <Route
        exact
        path={`${baseUrl}/dealer-request-approval`}
        component={DealerWalletListingApproval}
      />
      {/* {role.includes(13) && (
        <>
        <Route
          exact
          path={`${baseUrl}/dealer-finance-approval`}
          component={DealerFinance}
        />
        <Route
          exact
          path={`${baseUrl}/dealer-all-sites`}
          component={DealerAllSites}
        />
        </>
      )} */}
      <Route
        exact
        path={`${baseUrl}/request-internal-listing`}
        component={RequestInternal}
      />
      <Route
        exact
        path={`${baseUrl}/request-external-listing`}
        component={RequestExternal}
      />
      {/* Wallet Dashboard End */}
      {/* FIR Form  Starts*/}
      <Route
        exact
        path={`${baseUrl}/interaction-fir-form/:id`}
        component={FirstInteractionFIRForm}
      />
      <Route
        exact
        path={`${baseUrl}/corporate-interaction-form/:id`}
        component={CorporateMallForm}
      />
      {/* FIR Form  Ends*/}
      <Route
        exact
        path={`${baseUrl}/site-repository/:id/:lead_id`}
        component={SiteRepository}
      />
      <Route
        exact
        path={`${baseUrl}/uploaded-document-list/:site_id`}
        component={ViewUploadedDocuments}
      />
      <Route
        exact
        path={`${baseUrl}/update-rm-closed/:status/:id`}
        component={UpdateRMTicket}
      />
      <Route
        exact
        path={`${baseUrl}/site-repository-finance/:comm_id/:lead_id`}
        component={SiteRepositoryFinance}
      />
      <Route
        exact
        path={`${baseUrl}/task_form`}
        component={EngineerTasksForm}
      />
      <Route
        exact
        path={`${baseUrl}/task_form_add/:site_id`}
        component={SiteEngineerTasksForm}
      />
      <Route
        exact
        path={`${baseUrl}/tasks_engg`}
        component={EnggTasksDetails}
      />
      <Route exact path={`${baseUrl}/sso_login`} />
      <Route exact path={[`${baseUrl}`]} component={LoginSso} />
      <Route exact path={`${baseUrl}/profile`} component={Profile} />
      <Route exact path={`${baseUrl}/mrf`} component={CreateMrf} />
      <Route
        exact
        path={`${baseUrl}/mrf-listing/:list_type`}
        component={MrfListing}
      />
      <Route
        exact
        path={`${baseUrl}/sales-order-return-mrf`}
        component={SalesOrderReturn}
      />
      <Route
        exact
        path={`${baseUrl}/unclaimed-listing`}
        component={UnclaimedTransactionListing}
      />
      <Route
        exact
        path={`${baseUrl}/view-raised-claim/:pay_ref/:id`}
        component={ViewClaim}
      />
      <Route
        exact
        path={`${baseUrl}/mrf-approval-listing/:list_type`}
        component={ApprovalListing}
      />
      <Route
        exact
        path={`${baseUrl}/view-mrf/:list_type/:id`}
        component={ViewListing}
      />
      <Route exact path={`${baseUrl}/add-poc/:leadId`} component={AddPoc} />
      <Route
        exact
        path={`${baseUrl}/cl-ledger`}
        component={CreditLimitLedger}
      />
      <Route
        key="ins"
        exact
        path={`${baseUrl}/hoto-i-listing/:team/:listType`}
        component={HotoSiteListing}
      />
      <Route
        key="main"
        exact
        path={`${baseUrl}/hoto-m-listing/:team/:listType`}
        component={HotoSiteListing}
      />
      <Route
        key="insApp"
        exact
        path={`${baseUrl}/hoto-i-approval/:team/:listType`}
        component={HotoSiteListing}
      />
      <Route
        key="mainApp"
        exact
        path={`${baseUrl}/hoto-m-approval/:team/:listType`}
        component={HotoSiteListing}
      />
      <Route
        key="instEng"
        exact
        path={`${baseUrl}/hoto-isite-listing/:team`}
        component={HotoSiteEngineerListing}
      />
      <Route
        key="mainEng"
        exact
        path={`${baseUrl}/hoto-msite-listing/:team`}
        component={HotoSiteEngineerListing}
      />
      <Route
        exact
        path={`${baseUrl}/hoto/change-assignee/:team/:siteId`}
        component={HotoChangeAsignee}
      />
      <Route
        exact
        path={`${baseUrl}/hoto/hoto-form/:team/:id?`}
        component={HotoMainForm}
      />
      <Route
        key="mainAppForm"
        exact
        path={`${baseUrl}/hoto/maintenance-approval/:id/:siteId`}
        component={HotoApproval}
      />
      <Route
        key="insAppForm"
        exact
        path={`${baseUrl}/hoto/installation-approval/:id/:siteId`}
        component={HotoApproval}
      />
      <Route
        exact
        path={`${baseUrl}/hoto/hoto-install-form/:id?`}
        component={HotoInstallForm}
      />
      <Route
        exact
        path={`${baseUrl}/employee-mrf`}
        component={EmpToEmpListing}
      />
      <Route
        exact
        path={`${baseUrl}/material-receiving`}
        component={MaterialReceiving}
      />
      <Route
        exact
        path={`${baseUrl}/receive-material/:id`}
        component={MaterialReceiveForm}
      />
      <Route
        exact
        path={`${baseUrl}/fulfill-mrf/:list_type/:id`}
        component={EmpFullfillmentForm}
      />
      <Route
        exact
        path={`${baseUrl}/user-credit-limit/:user_id`}
        component={IncreaseCreditLimit}
      />
      <Route
        exact
        path={`${baseUrl}/user-credit-limit-list`}
        component={UserCreditLimit}
      />
      <Route
        exact
        path={`${baseUrl}/contract-assets-mapping`}
        component={ContractListing}
      />
      <Route
        exact
        path={`${baseUrl}/contract-gate/:lead_id/:comm_id/:site_id`}
        component={ContractGates}
      />
      <Route
        exact
        path={`${baseUrl}/gate-material/:assets_mapping_id/:gate_id/:site_id`}
        component={MaterialAction}
      />
      <Route
        exact
        path={`${baseUrl}/helpdesk-listing`}
        component={UserHelpdeskListing}
      />
      <Route
        exact
        path={`${baseUrl}/config-helpdesk`}
        component={ConfigHelpdesk}
      />
      <Route exact path={`${baseUrl}/edit-config/:id`} component={EditConfig} />
      <Route
        exact
        path={`${baseUrl}/user-config-listing`}
        component={UserConfigListing}
      />
      <Route exact path={`${baseUrl}/add-user-config`} component={AddConfig} />
      <Route
        exact
        path={`${baseUrl}/edit-user-config/:id`}
        component={EditUserConfig}
      />
      <Route exact path={`${baseUrl}/user-request/`} component={UserRequest} />
      <Route exact path={`${baseUrl}/user-request-list`} component={Listing} />
      <Route
        exact
        path={`${baseUrl}/user-request-pending`}
        component={PendingList}
      />
      <Route
        exact
        path={`${baseUrl}/finance-request-pending`}
        component={PendingListingFinance}
      />
      <Route
        exact
        path={`${baseUrl}/helpdesk-hierarchy-list`}
        component={HierarchyListing}
      />
      <Route
        exact
        path={`${baseUrl}/request-view/:id`}
        component={UserRequestView}
      />
      <Route
        exact
        path={`${baseUrl}/approved-rejected-list`}
        component={ApprovedAndRejectedList}
      />
      <Route
        exact
        path={`${baseUrl}/back-modification-request`}
        component={BackToModificationRequest}
      />
      <Route
        exact
        path={`${baseUrl}/manager-approved-rejected-list`}
        component={ManagerApprovalRejectedList}
      />
      {/*<Route exact path={`${baseUrl}/cl-ledger`} component={CreditLimitLedger} />*/}
      <Route
        exact
        path={`${baseUrl}/edit-poc/:leadId/:id`}
        component={AddPoc}
      />
      <Route exact path={`${baseUrl}/add-gate/:id`} component={AddGate} />
      <Route
        exact
        path={`${baseUrl}/preSalesListing`}
        component={PreSalesListing}
      />
      <Route
        exact
        path={`${baseUrl}/postSalesListing`}
        component={PostSalesListing}
      />
      <Route
        exact
        path={`${baseUrl}/pm-dashboa`}
        component={PmSitiesDashboard}
      />
      <Route exact path={`${baseUrl}/getCredits`} component={CreditPolicy} />
      <Route
        exact
        path={`${baseUrl}/getEmployeeCredits`}
        component={EmployeeCreditPolicy}
      />
      <Route
        exact
        path={`${baseUrl}/approved-sales-listing`}
        component={ApprovedSalesListing}
      />
      <Route
        exact
        path={`${baseUrl}/sales-targets`}
        component={SalesTargetsListing}
      />
      <Route
        exact
        path={`${baseUrl}/site-challan/:site_id/:manageId?`}
        component={ApprovedSalesChallan}
      />
      <Route
        exact
        path={`${baseUrl}/add-invoice-number/:id/:leadId/:manageId?`}
        component={AddInvoiceNum}
      />
      <Route
        exact
        path={`${baseUrl}/businessList`}
        component={BusinessListing}
      />
      <Route
        exact
        path={`${baseUrl}/paymentRequest`}
        component={PaymentRequest}
      />
      <Route
        exact
        path={`${baseUrl}/performaInvoice`}
        component={PerformaInvoiceListing}
      />
      <Route
        exact
        path={`${baseUrl}/taxInvoice`}
        component={TaxInvoiceListing}
      />
      <Route
        exact
        path={`${baseUrl}/taxInvoiceLob`}
        component={taxInvoiceLobListing}
      />
      <Route
        exact
        path={`${baseUrl}/vendorRequestList`}
        component={VendorRequestList}
      />
      <Route
        exact
        path={`${baseUrl}/vendorOnboardedList`}
        component={VendorOnboardedListing}
      />
      <Route
        exact
        path={`${baseUrl}/vendorOnboardedList/:status`}
        component={VendorOnboardedListing}
      />
      <Route
        exact
        path={`${baseUrl}/approval_pending_vendor_details/:id`}
        component={ViewVendorDetail}
      />
      <Route
        exact
        path={`${baseUrl}/vendor_onboard_details/:id`}
        component={ViewVendorDetail}
      />
      <Route
        exact
        path={`${baseUrl}/vendorPaymentList`}
        component={VendorPaymentList}
      />
      <Route
        exact
        path={`${baseUrl}/add_vendor_req`}
        component={VendorRequest}
      />
      <Route
        exact
        path={`${baseUrl}/add_vendor_bank_detail/:vendorId`}
        component={AddVendorBankDetail}
      />
      <Route
        exact
        path={`${baseUrl}/add_vendor_address/:vendorId`}
        component={VendorAddressForm}
      />
      <Route
        exact
        path={`${baseUrl}/edit_vendor_address/:vendorId/:addressId`}
        component={VendorAddressForm}
      />
      <Route
        exact
        path={`${baseUrl}/add_invoice_payment/:id/:d?`}
        component={VendorPayment}
      />
      <Route
        exact
        path={`${baseUrl}/invoice-request-list`}
        component={InvoiceRequestList}
      />
      <Route
        exact
        path={`${baseUrl}/invoice-request-detail/:vendor_id/:id?`}
        component={PaymentInvoiceRequestDetails}
      />
      <Route
        exact
        path={`${baseUrl}/add_advance_invoice_payment/:id/:d?`}
        component={VendorPaymentAdvance}
      />
      <Route
        exact
        path={`${baseUrl}/vendorPaymentDetails/:id`}
        component={VendorPaymentDetails}
      />
      <Route
        exact
        path={`${baseUrl}/addPaymentRequest/:id`}
        component={VendorPaymentRequest}
      />
      <Route
        exact
        path={`${baseUrl}/modify-request/:vendor_id/:request_id/:status/:id`}
        component={VendorPaymentModification}
      />
      <Route
        exact
        path={`${baseUrl}/vendorPaymentRequestList`}
        component={VendorPaymentRequestList}
      />
      <Route
        exact
        path={`${baseUrl}/vendorPaymentRequestDetails/:id`}
        component={VendorPaymentRequestDetails}
      />
      <Route
        exact
        path={`${baseUrl}/toolkit-inspection`}
        component={ToolkitInspection}
      />
      <Route
        exact
        path={`${baseUrl}/toolkit-inspection-form`}
        component={ToolkitInspectionForm}
      />
      <Route
        exact
        path={`${baseUrl}/toolkit-inspection-view/:id`}
        component={ToolkitInspectionView}
      />
      <Route
        exact
        path={`${baseUrl}/vendorPaymentRequestApproval/:id`}
        component={VendorPaymentRequestApproval}
      />
      <Route
        exact
        path={`${baseUrl}/vendorPaymentRequestApprovalPage/:id`}
        component={VendorPaymentRequestApprovalPage}
      />
      <Route
        exact
        path={`${baseUrl}/vendorPaymentRequestApprovalList`}
        component={VendorPaymentRequestApprovalList}
      />
      <Route
        exact
        path={`${baseUrl}/vendorHoldApproveList`}
        component={HoldApprovalForm}
      />
      <Route
        exact
        path={`${baseUrl}/inspection-form-mail/:id`}
        component={InspectionFormMail}
      />
      <Route
        exact
        path={`${baseUrl}/inspection-form/:id`}
        component={InspectionForm}
      />
      <Route
        exact
        path={`${baseUrl}/inspection-created/:id`}
        component={InspectionCreated}
      />
      <Route
        exact
        path={`${baseUrl}/inspection-requests`}
        component={InspectionRequests}
      />
      <Route
        exact
        path={`${baseUrl}/contract-sales-listing/:leadType/:id`}
        component={ContractSalesListing}
      />
      <Route
        exact
        path={`${baseUrl}/external-user-list/:lead_id`}
        component={ExternalUserList}
      />
      <Route exact path={`${baseUrl}/followUp/:id`} component={followUp} />
      <Route exact path={`${baseUrl}/viewPoc/:id`} component={ViewPocs} />
      <Route
        exact
        path={`${baseUrl}/add-follow-up-cop-resident/:id?`}
        component={CreateFollowUp}
      />
      <Route
        exact
        path={`${baseUrl}/add-follow-up-supply/:id`}
        component={SupplyFollowUp}
      />
      <Route
        exact
        path={`${baseUrl}/add-follow-up-b2bAlliances/:id`}
        component={B2BAlliancesFollowUp}
      />
      <Route exact path={`${baseUrl}/approvals`} component={ApprovalList} />
      <Route
        exact
        path={`${baseUrl}/renew-approvals`}
        component={RenewApprovals}
      />
      <Route
        exact
        path={`${baseUrl}/inspection_approvals`}
        component={InspectionApprovals}
      />
      <Route
        exact
        path={`${baseUrl}/tag_mismatch_approvals`}
        component={TagApprovals}
      />
      <Route
        exact
        path={`${baseUrl}/site_incentive`}
        component={SiteIncentive}
      />
      <Route
        exact
        path={`${baseUrl}/site_incentive_list`}
        component={SiteIncentiveListing}
      />
      <Route exact path={`${baseUrl}/add_incentive`} component={AddIncentive} />
      <Route
        exact
        path={`${baseUrl}/edit_incentive/:id/:site_id`}
        component={AddIncentive}
      />
      <Route
        exact
        path={`${baseUrl}/lead_approvals`}
        component={LeadApproval}
      />
      <Route
        exact
        path={`${baseUrl}/view-project-approval/:type/:id`}
        component={ViewDetailForApproval}
      />
      <Route
        exact
        path={`${baseUrl}/inspection-details/:id`}
        component={InspectionDetails}
      />
      <Route
        exact
        path={`${baseUrl}/tag-mismatch-details/:id`}
        component={TagMismatchDetails}
      />
      <Route
        exact
        path={`${baseUrl}/view-details/:id`}
        component={ViewDetails}
      />
      <Route
        exact
        path={`${baseUrl}/lead-details/:id/:manageId?`}
        component={ViewLead}
      />
      <Route
        exact
        path={`${baseUrl}/project-configuration/:id/:manageId?`}
        component={ProjectConfiguration}
      />
      <Route
        exact
        path={`${baseUrl}/site-consumes/:commId/:id/:manageId?`}
        component={SiteConsumes}
      />
      <Route
        exact
        path={`${baseUrl}/contract-details/:id/:manageId?`}
        component={ContractLead}
      />
      <Route
        exact
        path={`${baseUrl}/assignee/:id`}
        component={ChangeAssignee}
      />
      <Route
        exact
        path={`${baseUrl}/view-follow-up/:id`}
        component={ViewFollowUp}
      />
      <Route
        exact
        path={`${baseUrl}/meeting-history/:id/:manageId?`}
        component={Meetings}
      />
      <Route
        exact
        path={`${baseUrl}/schedule-meeting/:id/:meetingId?`}
        component={ScheduleMeeting}
      />
      <Route
        exact
        path={`${baseUrl}/meeting-details-scheduled/:id`}
        component={MeetingDetail}
      />
      <Route
        exact
        path={`${baseUrl}/site-assignee/:id/:manageId?`}
        component={SiteAssignee}
      />
      <Route
        exact
        path={`${baseUrl}/site-stage/:id/:manageId?`}
        component={SiteStages}
      />
      <Route
        exact
        path={[
          `${baseUrl}/validate-location/:id`,
          `${baseUrl}/pm-sites/validate-location/:id`,
        ]}
        component={ValidateLocation}
      />
      <Route
        exact
        path={`${baseUrl}/set-target-date/:id/:manageId?`}
        component={SetTargetDate}
      />
      <Route
        exact
        path={`${baseUrl}/gate/:gate/:id/stage/:stageId`}
        component={SiteInspection}
      />
      <Route
        exact
        path={`${baseUrl}/site_inspection_material/:id/stage/:stageId`}
        component={SiteInspectionMaterial}
      />
      <Route
        exact
        path={`${baseUrl}/required-documents/:site_id`}
        component={RequiredDocuments}
      />
      <Route
        exact
        path={`${baseUrl}/inventory/:id/stage/:stageId/:gateId?`}
        component={InventoryChecklist}
      />
      <Route
        exact
        path={`${baseUrl}/vendor-allocation/:pr_sub_type/:id/:manageId`}
        component={VendorAllocation}
      />
      <Route
        exact
        path={`${baseUrl}/manage-vendor/:id/:vendor_id/:pr_sub_type`}
        component={ManageVendor}
      />
      <Route
        exact
        path={`${baseUrl}/vendor-allocation/:pr_sub_type/:id`}
        component={VendorAllocation}
      />
      <Route
        exact
        path={`${baseUrl}/manage-vendor/:id/:vendor_id/:pr_sub_type`}
        component={ManageVendor}
      />
      <Route
        exact
        path={`${baseUrl}/site-info/:id/stage/:stageId/:gateId?`}
        component={SiteInfoCheckList}
      />
      <Route
        exact
        path={`${baseUrl}/civil-check/:id/stage/:stageId/:gateId?`}
        component={CivilCheckout}
      />
      <Route
        exact
        path={`${baseUrl}/first_interaction_checklist/:id/stage/:stageId/:gateId?`}
        component={FirstInteraction}
      />
      <Route
        exact
        path={`${baseUrl}/configuration_and_testing/:id/stage/:stageId/:gateId?`}
        component={ConfigurationAndTesting}
      />
      <Route
        exact
        path={`${baseUrl}/go_live/:id/stage/:stageId/:gateId?`}
        component={GoLiveValet}
      />
      <Route
        exact
        path={`${baseUrl}/hardware-installation/:id/stage/:stageId/:gateId?`}
        component={HardwareInstall}
      />
      <Route
        exact
        path={`${baseUrl}/vendor-allocation/:id`}
        component={VendorAllocation}
      />
      <Route
        exact
        path={`${baseUrl}/handover_checklist/:id/stage/:stageId/:gateId?`}
        component={HandOver}
      />
      <Route
        exact
        strict
        path={`${baseUrl}/edit-project/:id`}
        component={EditProject}
      />
      <Route
        exact
        strict
        path={`${baseUrl}/business-addresses/:lead_id`}
        component={businessAddressListing}
      />
      <Route exact path={`${baseUrl}/check_in`} component={AttendanceDetails} />
      <Route
        exact
        path={`${baseUrl}/attendance/check-in-checkout`}
        component={DarwinCheckInOut}
      />
      <Route
        exact
        path={`${baseUrl}/dynamic-contents`}
        component={DynamicContentsList}
      />
      <Route
        exact
        path={`${baseUrl}/dynamic-contents/add`}
        component={DynamicContentsAdd}
      />
      <Route
        exact
        path={`${baseUrl}/dynamic-contents/edit/:id`}
        component={DynamicContentsEdit}
      />
      <Route
        exact
        path={`${baseUrl}/dynamic-contents/view/:id`}
        component={DynamicContentsView}
      />
      <Route exact path={`${baseUrl}/check_out`} component={checkoutDetails} />
      <Route exact path={`${baseUrl}/supervisor`} component={Supervisor} />
      <Route
        exact
        path={`${baseUrl}/SupervisorList`}
        component={SupervisorList}
      />
      <Route
        exact
        path={`${baseUrl}/getMonthlyData`}
        component={AbscondDriverList}
      />
      <Route
        exact
        path={`${baseUrl}/site-lead-referral`}
        component={SiteLeadReferralList}
      />
      <Route
        exact
        path={`${baseUrl}/client-client-referral`}
        component={ClientClientReferralList}
      />
      <Route
        exact
        path={`${baseUrl}/valet-referral`}
        component={ValetReferralForm}
      />
      <Route
        exact
        path={`${baseUrl}/device-delink`}
        component={DeviceDelink}
      />
      <Route exact path={`${baseUrl}/valetList`} component={ValetList} />
      <Route
        exact
        path={`${baseUrl}/valet-chat-list`}
        component={ValetChatList}
      />
      <Route
        exact
        path={`${baseUrl}/valet-chat-list-view/:message_id`}
        component={ValetChartListView}
      />
      <Route exact path={`${baseUrl}/valet`} component={Valet} />
      <Route exact path={`${baseUrl}/infra-zone`} component={InfraZone} />
      <Route
        exact
        path={`${baseUrl}/infra-zone-listing`}
        component={ZoneListing}
      />
      <Route exact path={`${baseUrl}/project`} component={Projects} />
      <Route exact path={`${baseUrl}/valet-salary`} component={ValetSalary} />
      <Route
        exact
        path={`${baseUrl}/master-salary-penalty`}
        component={MasterSalaryPenalty}
      />
      <Route
        exact
        path={`${baseUrl}/suggest-master-salary-penalty`}
        component={Penalty}
      />
      <Route
        exact
        path={`${baseUrl}/internal-communication`}
        component={InternalCommunication}
      />
      <Route
        exact
        path={`${baseUrl}/monthly-valet-salary/:phone/:status/:month/:year`}
        component={MonthlyValetSalary}
      />
      <Route
        exact
        path={`${baseUrl}/monthly-valet-salary-report`}
        component={MonthlyValetSalary}
      />
      <Route exact path={`${baseUrl}/salary-master`} component={SalaryMaster} />
      <Route exact path={`${baseUrl}/event-salary`} component={EventSalary} />
      <Route
        exact
        path={`${baseUrl}/advance-salary/list`}
        component={AdvanceSalary}
      />
      <Route
        exact
        path={`${baseUrl}/incentive-slab`}
        component={IncentiveSlab}
      />
      <Route exact path={`${baseUrl}/tag-list`} component={ListTag} />
      pm-sities
      <Route exact path={`${baseUrl}/save-tag`} component={SaveTag} />
      <Route
        exact
        path={`${baseUrl}/location-approvals`}
        component={LocationApprovalsList}
      />
      <Route
        exact
        path={`${baseUrl}/abort-site-approvals`}
        component={SiteAbortApprovalsList}
      />
      <Route
        exact
        path={`${baseUrl}/approvals/pm-site-state-approvals`}
        component={PmSiteApprovals}
      />
      <Route
        exact
        path={[
          `${baseUrl}/material-requisition/:id/stage/:stageId`,
          `${baseUrl}/view-material-requisition/:id/stage/:stageId`,
        ]}
        component={MaterialRequisition}
      />
      <Route
        exact
        path={`${baseUrl}/mrf-edit/:id/:gateId`}
        component={MrfEdit}
      />
      <Route
        exact
        path={`${baseUrl}/view-site-engineer-details/:id`}
        component={SiteEngineerDetails}
      />
      <Route
        exact
        path={`${baseUrl}/material-delivery/:id/stage/:stageId`}
        component={MaterialDelivery}
      />
      <Route
        exact
        path={`${baseUrl}/tag-delivery/:id/stage/:stageId`}
        component={TagDelivery}
      />
      <Route
        exact
        path={`${baseUrl}/pos-shipment/:id/stage/:stageId`}
        component={PosShipment}
      />
      <Route
        exact
        path={`${baseUrl}/employee-pos-stock`}
        component={EmployeePosMapping}
      />
      <Route
        exact
        path={`${baseUrl}/mrf-approvals`}
        component={MrfApprovalsList}
      />
      {/* <Route
        exact
        path={`${baseUrl}/sites-location-map`}
        component={SitesLocationMap}
      /> */}
      <Route
        exact
        path={`${baseUrl}/employee-tickets-list`}
        component={EmpTicketsListing}
      />
      <Route
        exact
        path={`${baseUrl}/employee-create-ticket`}
        component={EmpCreateTicket}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/sites-listing`}
        component={BrandActivation}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/site-maintenance-user`}
        component={SiteMaintenance}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/renewal-listing`}
        component={RenewalListing}
      />
      <Route
        exact
        path={`${baseUrl}/bulk-assignment`}
        component={AssignmentForm}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/site-details/:id/:leadId?`}
        component={ViewSitedetails}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/viewPoc/:id/:leadId?`}
        component={BaViewPocs}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/add-poc/:siteId`}
        component={BaAddPoc}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/edit-poc/:siteId/:id/:status`}
        component={BaAddPoc}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/scheduled-meetings/:id/:leadId?`}
        component={ScheduledMeetings}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/scheduled-meeting`}
        component={MeetingTracker}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/users-rating`}
        component={UsersRating}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/score-card-by-hod`}
        component={ScoreByHod}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/score-card-by-senior`}
        component={ScoreBySenior}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/meetings-rating`}
        component={MeetingRating}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/user-details/:id`}
        component={UserView}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/meeting-details/:id`}
        component={MeetingView}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/view-cheque-picked`}
        component={ChequePicked}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/create-mom/:siteId/:id`}
        component={CreateMom}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/plan-schedule`}
        component={PlanSchedule}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/view-mom/:id`}
        component={ViewMom}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/feedback`}
        component={Feedback}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/feedback-details/:id`}
        component={FeedbackDetails}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/schedule-new-meeting/:draft_id`}
        component={ScheduleNewMeeting}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/check-in-meeting`}
        component={CheckIn}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/edit-schedule-meeting/:draft_id`}
        component={SaveAsDraft}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/schedule-a-meeting/:siteId`}
        component={ScheduleAMeeting}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/reschedule-a-meeting/:siteId/:id`}
        component={ScheduleAMeeting}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/scheduled-meeting-details/:id`}
        component={MeetingDetails}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/scheduled-meeting-detail/:id`}
        component={BAMeetingDetail}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/create-minutes-of-meeting/:id`}
        component={MinutesOfMeeting}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/view-minutes-of-meeting/:id`}
        component={ViewMomDetails}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/products`}
        component={ProductsList}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/product-details/:id`}
        component={ProductDetails}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/knowledge-center`}
        component={KnowledgeCenter}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/conduct-camp/camp/:siteId/:leadId?`}
        component={ConductCamp}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/conduct-camp/approval`}
        component={ApprovalCampListing}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/conduct-camp/meeting/:siteId`}
        component={ScheduleCamp}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/conduct-camp/details/:id`}
        component={CampDetails}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/conduct-camp/payment/:id`}
        component={MakePayment}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/conduct-camp/create-minutes-of-meeting/:siteId?/:id`}
        component={CampMinutesOfMeeting}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/conduct-camp/view-minutes-of-meeting/:id`}
        component={CampViewMomDetails}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/conduct-camp/vendor/:siteId?/:id`}
        component={CampVendorAllocation}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/conduct-camp/pre-camp/:siteId/:id`}
        component={PreCamp}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/conduct-camp/post-camp/:siteId/:id`}
        component={PostCamp}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/conduct-carnival/carnival`}
        component={ConductCarnival}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/conduct-site-carnival/carnival/:siteId`}
        component={ConductSiteCarnival}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/helpdesk`}
        component={HelpdeskListing}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/add-helpdesk`}
        component={AddHelpdesk}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/helpdesk/details/:id`}
        component={HelpdeskDetails}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/helpdesk/update/:id`}
        component={UpdateHelpdesk}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/helpdesk/create-duplicate/:id`}
        component={DuplicateHelpdesk}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/conduct-carnival/add-carnival`}
        component={AddCarnival}
      />
      {/* <Route
        exact
        path={`${baseUrl}/brand-activation/conduct-carnival/add-carnival-stage/:infra_id`}
        component={AddCarnivalThroughStage}
      /> */}
      <Route
        exact
        path={`${baseUrl}/brand-activation/conduct-carnival/add-carnival-stage/:siteId/:infra_id/:carnival_type?`}
        // path={`${baseUrl}/brand-activation/conduct-carnival/add-carnival-stage/:siteId/:carnival_type?`}
        component={AddCarnivalThroughStage}
      />
      <Route
        exact
        path={`${baseUrl}/project-onboarding/list`}
        component={ProjectOnboarding}
      />
      <Route
        exact
        path={`${baseUrl}/project-onboarding/onboard-project-form`}
        component={OnboardProject}
      />
      <Route
        exact
        path={`${baseUrl}/project-onboarding/addQuotation/:id`}
        component={AddQuotation}
      />
      <Route
        exact
        path={`${baseUrl}/project-onboarding/quotations`}
        component={ViewQuotations}
      />
      <Route
        exact
        path={`${baseUrl}/project-onboarding/approve-quotations`}
        component={ViewApproveQuotations}
      />
      <Route
        exact
        path={`${baseUrl}/project-onboarding/approve-quotation/:id`}
        component={ApproveQuotations}
      />
      <Route
        exact
        path={`${baseUrl}/project-onboarding/view-quotation/:id`}
        component={ViewQuotation}
      />
      <Route
        exact
        path={`${baseUrl}/project-onboarding/edit-quotation/:id`}
        component={EditQuotation}
      />
      <Route
        exact
        path={`${baseUrl}/project-onboarding/quotation-history`}
        component={QuotationHistory}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/conduct-normal/add-normal`}
        component={NormalOnboarding}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/conduct-normal/list-normal`}
        component={ListingNormal}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/carnival/details/:id`}
        component={CarnivalDetails}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/carnival/update/:id`}
        component={UpdateCarnival}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/conduct-normal/update/:id`}
        component={UpdateNormalOnboarding}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/carnival/create-duplicate/:id`}
        component={DuplicateCarnival}
      />
      <Route
        exact
        path={`${baseUrl}/fd-tickets`}
        component={FdTicketsListing}
      />
      <Route exact path={`${baseUrl}/scanner`} component={Scanner} />
      <Route
        exact
        path={`${baseUrl}/brand-activation/fd-tickets/create`}
        component={CreateFdTicket}
      />
      <Route
        exact
        path={`${baseUrl}/view-fd-ticket/:id`}
        component={ViewTicket}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/corporate-list/:id/:leadId?`}
        component={CorporateList}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/add-corporate-client/:id`}
        component={AddCorporateClient}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/checkout`}
        component={Checkout}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/corporate-client/poc/:siteId/:id`}
        component={CorpClientPoc}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/corporate-client/add-poc/:siteId/:clientId`}
        component={ManageAddPoc}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/corporate-client/edit-poc/:siteId/:clientId/:id`}
        component={ManageAddPoc}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/invoice`}
        component={InvoiceList}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/change-assignee/:siteId/:leadId?`}
        component={BaChangeAssignee}
      />
      <Route
        exact
        path={`${baseUrl}/site-maintenance/change-assignee/:siteId/:leadId?`}
        component={MaintenanceChangeAssignee}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/renew-contract/:siteId/:leadId?`}
        component={RenewContract}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/edit-contract-poc/:siteId/:leadId?`}
        component={UpdatePoc}
      />
      <Route
        exact
        path={`${baseUrl}/edit-renew-contract/:contractId/:leadId?`}
        component={EditContractRenewal}
      />
      <Route
        exact
        path={`${baseUrl}/brand-activation/invoice/view-details/:id`}
        component={InvoiceViewDetails}
      />
      <Route
        exact
        path={`${baseUrl}/ticket-listing`}
        component={TicketsListing}
      />
      <Route
        exact
        path={`${baseUrl}/ticket-details/:id`}
        component={TicketDetails}
      />
      <Route exact path={`${baseUrl}/create-ticket`} component={CreateTicket} />
      <Route
        exact
        path={`${baseUrl}/service-pr-list`}
        component={ServicePrLisitng}
      />
      <Route
        exact
        path={`${baseUrl}/service-pr-approvals`}
        component={ServicePrApprovalsList}
      />
      <Route
        exact
        path={`${baseUrl}/pr-confirmation/:vendor_id/:pr_id`}
        component={PrConfirmation}
      />
      <Route
        exact
        path={`${baseUrl}/pr-confirmation-details/:pr_id`}
        component={PrConfirmationDetails}
      />
      <Route
        exact
        path={`${baseUrl}/raise-update-installation-date-request/:comm_id/:site_id/:lead_id`}
        component={RaiseUpdateInstallationDate}
      />
      <Route
        exact
        path={`${baseUrl}/installation-request-listing/:comm_id/:site_id/:lead_id`}
        component={InstallationRequestListing}
      />
      <Route
        exact
        path={`${baseUrl}/postpone-installation-approvals`}
        component={PostponeInstallationApprovalsList}
      />
      <Route
        exact
        path={`${baseUrl}/update-installation-date/:comm_id/:id`}
        component={RaiseUpdateInstallationDate}
      />
      <Route
        exact
        path={`${baseUrl}/request-listing/:comm_id/:id`}
        component={InstallationRequestListing}
      />
      <Route
        exact
        path={`${baseUrl}/view-postpone-installation-details/:id`}
        component={ViewPostponeInstallationDetails}
      />
      <Route
        exact
        path={`${baseUrl}/contract-expiry`}
        component={ContractExpiryList}
      />
      <Route
        exact
        path={`${baseUrl}/contract-expiry/raise-renewal-request/:site_id`}
        component={RaiseRenewalRequest}
      />
      <Route
        exact
        path={`${baseUrl}/contract-expiry/request-list`}
        component={RenewalRequestList}
      />
      <Route
        exact
        path={`${baseUrl}/contract-expiry/request-details/:id`}
        component={RenewalRequestDetails}
      />
      <Route
        exact
        path={`${baseUrl}/lead-details-v2/:site_id/:lead_id`}
        component={ViewLeadV2}
      />
      <Route
        exact
        path={`${baseUrl}/view-lead-details/:lead_id/:site_id`}
        component={ViewLeadV2}
      />
      <Route
        exact
        path={`${baseUrl}/contract-expiry/raised-requests/:site_id?/:id?`}
        component={RaisedRequestsList}
      />
      <Route
        exact
        path={`${baseUrl}/competition-mapping`}
        component={CompetitionMapping}
      />
      <Route
        exact
        path={`${baseUrl}/competition-mapping-list`}
        component={CompetitionMappingList}
      />
      <Route
        exact
        path={`${baseUrl}/offrole-employees-list`}
        component={ApproveRejectList}
      />
      <Route
        exact
        path={`${baseUrl}/active-reactive-list`}
        component={ActiveReactivateList}
      />
      <Route exact path={`${baseUrl}/generate-link`} component={GenerateLink} />
      <Route
        exact
        path={`${baseUrl}/approve-reject-employee-request/:id`}
        component={EmployeeRequest}
      />
      <Route
        exact
        path={`${baseUrl}/update-request/:user_id`}
        component={UpdateRequest}
      />
      <Route
        exact
        path={`${baseUrl}/active-inactive-employee/:user_id`}
        component={ActiveInactive}
      />
      <Route
        exact
        path={`${baseUrl}/procurement/brand-list`}
        component={BrandList}
      />
      <Route
        exact
        path={`${baseUrl}/procurement/add_brand`}
        component={CreateBrand}
      />
      <Route
        exact
        path={`${baseUrl}/procurement/category-list`}
        component={CategoryList}
      />
      <Route
        exact
        path={`${baseUrl}/procurement/add_category`}
        component={AddCategory}
      />
      <Route
        exact
        path={`${baseUrl}/procurement/hsn-list`}
        component={HsnList}
      />
      <Route
        exact
        path={`${baseUrl}/procurement/add_hsn`}
        component={CreateHsn}
      />
      <Route
        exact
        path={`${baseUrl}/procurement/mrf-types`}
        component={MrfTypes}
      />
      <Route
        exact
        path={`${baseUrl}/procurement/add-mrf-type`}
        component={CreateMrfType}
      />
      <Route
        exact
        path={`${baseUrl}/procurement/edit-mrf-type/:id`}
        component={EditMrfType}
      />
      <Route
        exact
        path={`${baseUrl}/procurement/business-materials`}
        component={MaterialList}
      />
      <Route
        exact
        path={`${baseUrl}/procurement/business-services`}
        component={ServiceList}
      />
      <Route
        exact
        path={`${baseUrl}/procurement/create-item`}
        component={CreateBusinessItem}
      />
      <Route
        exact
        path={`${baseUrl}/procurement/edit-item/:type/:id`}
        component={EditBusinessItem}
      />
      <Route
        exact
        path={`${baseUrl}/procurement/view-item/:type/:id`}
        component={ViewBusinessItem}
      />
      {(activeComponents === "b2b-alliances") && (
        <Switch>
          <Route
            exact
            path={`${baseUrl}/pre-sales-b2b-alliance/:id`}
            component={B2bAlliance}
          />
          <Route
            exact
            strict
            path={`${baseUrl}/edit-details/:id`}
            component={EditB2bAlliances}
          />
          <Route
            exact
            path={`${baseUrl}/b2b-alliances`}
            component={B2bAlliances}
          />
          <Route
            exact
            path={`${baseUrl}/post-sales-b2b-alliance/:id`}
            component={PostB2bAlliance}
          />
          {(departmentIds.includes(3) || departmentIds.includes(2)) && (
            <Switch>
              <Route
                exact
                path={`${baseUrl}/ticket-listing`}
                component={TicketsListing}
              />
              <Route
                exact
                path={`${baseUrl}/ticket-details/:id`}
                component={TicketDetails}
              />
            </Switch>
          )}
          <Route path="*" component={Notfound} />
        </Switch>
      )}
      {(activeComponents === "supply" || activeComponents === "parking") && (
        <Switch>
          <Route
            exact
            path={`${baseUrl}/pm-dashboard`}
            component={PmSitiesDashboard}
          />
          <Route exact path={`${baseUrl}/supply`} component={Supply} />
          <Route
            exact
            strict
            path={`${baseUrl}/edit-details/:id`}
            component={EditSupply}
          />
          <Route
            exact
            path={`${baseUrl}/add-contract-apt/:lead_id`}
            component={ContractApt}
          />
          <Route
            exact
            path={`${baseUrl}/edit-contract-apt/:id/:manageId?`}
            component={EditAptContract}
          />
          <Route
            exact
            path={`${baseUrl}/add-contract-corporate/:lead_id`}
            component={contractCorporate}
          />
          <Route
            exact
            path={`${baseUrl}/edit-contract-corp/:id/:manageId?`}
            component={EditCorpContract}
          />
          <Route
            exact
            path={`${baseUrl}/preSalesSupply/:id`}
            component={PreSalesSupply}
          />
          <Route
            exact
            path={`${baseUrl}/post-sales-supply/:lead_id`}
            component={PostSalesSupply}
          />
          <Route
            exact
            path={`${baseUrl}/edit-contract-supply/:id/:manageId?`}
            component={EditSupplyContract}
          />
          <Route
            exact
            path={`${baseUrl}/site-listing`}
            component={SiteListing}
          />
          <Route
            exact
            path={`${baseUrl}/return-tag/:id/:lead_id`}
            component={ReturnTag}
          />
          <Route
            exact
            path={`${baseUrl}/site-log/:id/:com_id`}
            component={SiteLog}
          />
          <Route
            exact
            path={`${baseUrl}/go-live-site`}
            component={GoLiveSites}
          />
          <Route
            exact
            path={`${baseUrl}/site-listing-maintenance`}
            component={SiteListingMaintenance}
          />
          <Route
            exact
            path={`${baseUrl}/create-pm-list/:id`}
            component={CreatePmList}
          />
          <Route
            exact
            path={`${baseUrl}/pm_checklist/:id`}
            component={PmCheckList}
          />
          <Route
            exact
            path={`${baseUrl}/view-pm-list/:id/:manageId`}
            component={PmSitesCheckList}
          />
          <Route
            exact
            path={`${baseUrl}/pm-checklist-ques/:id/:manageId/:gateId`}
            component={PmChecklistQues}
          />
          <Route
            exact
            path={`${baseUrl}/manage-pm/:id/:manageId`}
            component={ManagePM}
          />

          <Route
            exact
            path={`${baseUrl}/approvals/rm-tickets/:date?`}
            component={ApprovalRmTickets}
          />
          <Route
            exact
            path={`${baseUrl}/software-rm-tickets/:date?`}
            component={SoftwareRmTickets}
          />
          <Route
            exact
            path={`${baseUrl}/hardware-rm-tickets/:date?`}
            component={HardwareRmTickets}
          />
          <Route
            exact
            path={`${baseUrl}/approvals/pm-sites`}
            component={ApprovalPmSites}
          />
          <Route
            exact
            path={`${baseUrl}/approvals/pm-tickets`}
            component={ApprovalPmTicket}
          />
          <Route
            exact
            path={`${baseUrl}/approvals/employee-ticket-list`}
            component={ApprovalEmTicketList}
          />
          <Route
            exact
            path={`${baseUrl}/view-report-pm/:id/:manageId`}
            component={ViewReportPmSites}
          />
          <Route
            exact
            path={[`${baseUrl}/rm-view-details/:id`, `${baseUrl}/rm-view/:id`]}
            component={ViewRmTicket}
          />
          <Route exact path={`${baseUrl}/rm-log/:id`} component={RmLog} />
          <Route exact path={`${baseUrl}/rm-show/:id`} component={RmView} />
          <Route
            exact
            path={`${baseUrl}/rm-assign-ticket/:id`}
            component={RmAssignTicket}
          />
          <Route
            exact
            path={`${baseUrl}/mrf/:type/:id/:siteId`}
            component={Mrf}
          />
          <Route
            exact
            path={`${baseUrl}/mrf/:id/:siteId`}
            component={CreateMrf}
          />
          <Route
            exact
            path={`${baseUrl}/rm-closed/:status/:id`}
            component={ClosedRmTicket}
          />
          <Route exact path={`${baseUrl}/pm-sities`} component={PmSities} />
          <Route
            exact
            path={`${baseUrl}/rm-tickets/:date?`}
            component={RmTickets}
          />
          <Route
            exact
            path={`${baseUrl}/software-rm-tickets/:date?`}
            component={SoftwareRmTickets}
          />
          <Route
            exact
            path={`${baseUrl}/hardware-rm-tickets/:date?`}
            component={HardwareRmTickets}
          />
          {(departmentIds.includes(3) || departmentIds.includes(2)) && (
            <Switch>
              <Route
                exact
                path={`${baseUrl}/ticket-listing`}
                component={TicketsListing}
              />
              <Route
                exact
                path={`${baseUrl}/ticket-details/:id`}
                component={TicketDetails}
              />
            </Switch>
          )}
          <Route path="*" component={Notfound} />
        </Switch>
      )}
      {activeComponents === "apartments" && (
        <Switch>
          <Route
            exact
            path={`${baseUrl}/post-sales-apartment/:lead_id`}
            component={PostSalesApartment}
          />

          <Route
            exact
            strict
            path={`${baseUrl}/edit-details/:id`}
            component={EditApartments}
          />
          <Route
            exact
            path={`${baseUrl}/add-contract-apt/:lead_id`}
            component={ContractApt}
          />
          <Route
            exact
            path={`${baseUrl}/edit-contract-corporate-v2/:comm_id/:lead_id`}
            component={contractCorporateEdit}
          />
          <Route
            exact
            path={`${baseUrl}/add-contract-corporate-v2/:lead_id`}
            component={contractCorporateNew}
          />
          <Route
            exact
            path={`${baseUrl}/edit-contract-apt/:id/:manageId?`}
            component={EditAptContract}
          />
          <Route
            exact
            path={`${baseUrl}/edit-contract-supply/:id/:manageId?`}
            component={EditSupplyContract}
          />
          <Route
            exact
            path={`${baseUrl}/add-invoice-number/:id/:leadId/:manageId?`}
            component={AddInvoiceNum}
          />
          <Route
            exact
            path={`${baseUrl}/edit-contract-corp/:id/:manageId?`}
            component={EditCorpContract}
          />
          <Route exact path={`${baseUrl}/apartments`} component={Apartments} />
          {(departmentIds.includes(3) || departmentIds.includes(2)) && (
            <Switch>
              <Route
                exact
                path={`${baseUrl}/ticket-listing`}
                component={TicketsListing}
              />
              <Route
                exact
                path={`${baseUrl}/ticket-details/:id`}
                component={TicketDetails}
              />
              <Route
                exact
                path={`${baseUrl}/add-invoice-number/:id/:leadId/:manageId?`}
                component={AddInvoiceNum}
              />
            </Switch>
          )}
          <Route path="*" component={Notfound} />
        </Switch>
      )}
      {role.includes(18) && (
        <Switch>
          <Route
            exact
            path={`${baseUrl}/file-complain`}
            component={FileComplain}
          />

          <Route
            exact
            path={`${baseUrl}/create-complain/:id`}
            component={CreateComplain}
          />

          <Route
            exact
            path={`${baseUrl}/edit-and-merge-complain/:id`}
            component={EditComplain}
          />

          <Route
            exact
            path={`${baseUrl}/complains-list`}
            component={ViewComplainList}
          />

          <Route
            exact
            path={`${baseUrl}/view-complain/:id`}
            component={ViewComplain}
          />

          <Route
            exact
            path={[`${baseUrl}/rm-view-details/:id`, `${baseUrl}/rm-view/:id`]}
            component={ViewRmTicket}
          />
          <Route exact path={`${baseUrl}/rm-log/:id`} component={RmLog} />
          <Route
            exact
            path={`${baseUrl}/complaint-log/:id`}
            component={ComplaintLog}
          />
          <Route
            exact
            path={`${baseUrl}/rm-closed/:status/:id`}
            component={ClosedRmTicket}
          />

          <Route
            exact
            path={[`${baseUrl}/rm-view-report/:id`, `${baseUrl}/rm-view/:id`]}
            component={ViewRmTicketReport}
          />

          <Route
            exact
            path={`${baseUrl}/complains/troubleshoot/:id`}
            component={Troubleshoot}
          />
          {(departmentIds.includes(3) || departmentIds.includes(2)) && (
            <Switch>
              <Route
                exact
                path={`${baseUrl}/ticket-listing`}
                component={TicketsListing}
              />
              <Route
                exact
                path={`${baseUrl}/ticket-details/:id`}
                component={TicketDetails}
              />
            </Switch>
          )}
          <Route path="*" component={Notfound} />
        </Switch>
      )}
      {(departmentId.includes(2) || teamId.includes(21)) && (
        <Switch>
          <Route
            exact
            path={`${baseUrl}/site-listing`}
            component={SiteListing}
          />
          <Route
            exact
            path={`${baseUrl}/add-contract-apt/:lead_id`}
            component={ContractApt}
          />
          <Route
            exact
            path={`${baseUrl}/edit-contract-apt/:id/:manageId?`}
            component={EditAptContract}
          />
          <Route
            exact
            path={`${baseUrl}/post-sales-supply/:lead_id`}
            component={PostSalesSupply}
          />
          <Route
            exact
            path={`${baseUrl}/edit-contract-supply/:id/:manageId?`}
            component={EditSupplyContract}
          />
          <Route exact path={`${baseUrl}/corporate`} component={Corporate} />
          <Route
            exact
            strict
            path={`${baseUrl}/edit-details/:id`}
            component={EditCorporate}
          />
          <Route
            exact
            path={`${baseUrl}/post-sales-corporate/:lead_id`}
            component={PostSalesCorporate}
          />
          <Route
            exact
            path={`${baseUrl}/add-contract-corporate/:lead_id`}
            component={contractCorporate}
          />
          <Route
            exact
            path={`${baseUrl}/add-contract-corporate-v2/:lead_id`}
            component={contractCorporateNew}
          />
          <Route
            exact
            path={`${baseUrl}/edit-contract-corporate-v2/:comm_id/:lead_id`}
            component={contractCorporateEdit}
          />
          <Route
            exact
            path={`${baseUrl}/edit-contract-corp/:id/:manageId?`}
            component={EditCorpContract}
          />

          <Route path="*" component={Notfound} />
        </Switch>
      )}
      {departmentId.includes(4) && (
        <Switch>
          <Route
            exact
            path={`${baseUrl}/dealer-finance-approval`}
            component={DealerFinance}
          />
          <Route
            exact
            path={`${baseUrl}/dealer-all-sites`}
            component={DealerAllSites}
          />
          <Route
            exact
            path={`${baseUrl}/finance-contract-listing`}
            component={FinanceContractList}
          />
          <Route
            exact
            path={`${baseUrl}/site-dashboard`}
            component={SiteDashboard}
          />
          <Route
            exact
            path={`${baseUrl}/site-detail/:siteId`}
            component={SiteDetailView}
          />
          <Route
            exact
            path={`${baseUrl}/client-contract-mapping/:comm_id/:lead_id`}
            component={ClientMapping}
          />
          <Route
            exact
            path={`${baseUrl}/client-business/:comm_id/:lead_id`}
            component={clientBusiness}
          />
          <Route
            exact
            path={`${baseUrl}/client-change/:comm_id/:lead_id`}
            component={ClientChange}
          />
          <Route
            exact
            path={`${baseUrl}/business-change/:comm_id/:lead_id`}
            component={BusinessChange}
          />
          <Route
            exact
            path={`${baseUrl}/finance-business-list`}
            component={financeBusinenessList}
          />
          <Route
            exact
            path={`${baseUrl}/finance-mrf-list`}
            component={FinanceMrfListing}
          />

          <Route
            exact
            path={`${baseUrl}/mrf-finance-view/:mrf_id`}
            component={MrfFinanceView}
          />

          <Route
            exact
            path={`${baseUrl}/abort-site-approvals-finance`}
            component={SiteAbortApprovalsListFinance}
          />
          <Route
            exact
            path={`${baseUrl}/approval-listing-finance`}
            component={FinanceApprovalListing}
          />
          <Route
            exact
            path={`${baseUrl}/finance-add-business`}
            component={financeAddBusiness}
          />
          <Route
            exact
            path={`${baseUrl}/add-location/:type/:lead_id`}
            component={AddLocationDetails}
          />
          <Route
            exact
            path={`${baseUrl}/add-client-location/:type/:lead_id/:client_id/:contract_id?`}
            component={AddClientLocation}
          />
          <Route
            exact
            path={`${baseUrl}/view-client-address/:client_id`}
            component={AddressListing}
          />
          <Route
            exact
            path={`${baseUrl}/client-list`}
            component={clientListing}
          />
          <Route
            exact
            path={`${baseUrl}/client-list/add`}
            component={AddClient}
          />
          <Route
            exact
            path={`${baseUrl}/incentive-list`}
            component={FinanceIncentive}
          />
          <Route
            exact
            path={`${baseUrl}/user_incentives`}
            component={UserIncentiveLists}
          />
          <Route
            exact
            path={`${baseUrl}/senior_incentives`}
            component={SeniorIncentiveLists}
          />
          <Route
            exact
            path={`${baseUrl}/head_incentives`}
            component={HeadIncentiveLists}
          />
          <Route path="*" component={Notfound} />
        </Switch>
      )}
      {(role.includes(53) || role.includes(61)) && (
        <Switch>
          <Route
            exact
            path={`${baseUrl}/complains-list-l2`}
            component={ViewComplainListSupport}
          />
          <Route
            exact
            path={`${baseUrl}/view-complain-l2/:id`}
            component={ViewComplainSupportTeam}
          />
          <Route
            exact
            path={`${baseUrl}/raise-issue-list`}
            component={RaiseIssue}
          />
          <Route
            exact
            path={`${baseUrl}/view-issue/:id`}
            component={ViewIssue}
          />
        </Switch>
      )}
      {departmentId.includes(3) ||
        (departmentId.includes(2) && (
          <Switch>
            <Route
              exact
              path={`${baseUrl}/ticket-listing`}
              component={TicketsListing}
            />
            <Route
              exact
              path={`${baseUrl}/ticket-details/:id`}
              component={TicketDetails}
            />
          </Switch>
        ))}
      {(activeComponents === "installation" ||
        departmentIds.includes(3) ||
        teamId.includes(21)) && (
        <Switch>
          <Route
            exact
            path={`${baseUrl}/site-asset-mapping`}
            component={SiteAssetMapping}
          />
          <Route
            exact
            path={`${baseUrl}/site-gates/:lead_id`}
            component={SiteGates}
          />
          <Route
            exact
            path={`${baseUrl}/asset-gate-mapping/:id/:gate_setup_id/:lead_id`}
            component={AssetMapping}
          />
          <Route
            exact
            path={`${baseUrl}/test-scanner`}
            component={ScannerTest}
          />
          <Route
            exact
            path={`${baseUrl}/new-site-asset-gate-mapping/:id/:gate_setup_id/:lead_id/:site_id`}
            component={NewSiteAssetMapping}
          />
          <Route
            exact
            path={`${baseUrl}/mapped-assets/:gate_id/:asset_mapping_id`}
            component={AssetMappingInfo}
          />
          <Route
            exact
            path={`${baseUrl}/new-site-asset-mapping/:id/:lead_id/`}
            component={ContractAssets}
          />
          <Route
            exact
            path={`${baseUrl}/site-engineer-list`}
            component={SiteEngineerList}
          />
          <Route
            exact
            path={`${baseUrl}/site-listing`}
            component={SiteListing}
          />
          <Route
            exact
            path={`${baseUrl}/site-listing-engg`}
            component={SiteListsForEngineer}
          />
          <Route
            exact
            path={`${baseUrl}/view-tasks-info/:id/:manageId?`}
            component={ViewDailyTaskDetails}
          />
          <Route
            exact
            path={`${baseUrl}/return-tag/:id/:lead_id`}
            component={ReturnTag}
          />

          <Route
            exact
            path={`${baseUrl}/task-listing`}
            component={TaskListing}
          />
          <Route
            exact
            path={`${baseUrl}/site-log/:id/:com_id`}
            component={SiteLog}
          />
          <Route
            exact
            path={`${baseUrl}/go-live-site`}
            component={GoLiveSites}
          />
          <Route
            exact
            path={`${baseUrl}/site-listing-maintenance`}
            component={SiteListingMaintenance}
          />
          <Route
            exact
            path={`${baseUrl}/go-live-site/change-assignee/:id`}
            component={GoLiveChangeAssignee}
          />
          <Route
            exact
            path={`${baseUrl}/create-pm-list/:id`}
            component={CreatePmList}
          />

          <Route
            exact
            path={`${baseUrl}/pm_checklist/:id`}
            component={PmCheckList}
          />

          <Route exact path={`${baseUrl}/pm-sities`} component={PmSities} />
          <Route
            exact
            path={`${baseUrl}/pm-dashboard`}
            component={PmSitiesDashboard}
          />
          <Route
            exact
            path={`${baseUrl}/view-pm-list/:id/:manageId`}
            component={PmSitesCheckList}
          />

          <Route
            exact
            path={`${baseUrl}/pm-checklist-ques/:id/:manageId/:gateId`}
            component={PmChecklistQues}
          />
          <Route exact path={`${baseUrl}/pm-tickets`} component={PmTickets} />
          <Route
            exact
            path={[
              `${baseUrl}/tickets/view-details/:id`,
              `${baseUrl}/tickets/view/:id`,
            ]}
            component={PMTicketDetails}
          />
          <Route
            exact
            path={`${baseUrl}/assign-ticket/:id`}
            component={PmAssignTicket}
          />
          <Route
            exact
            path={`${baseUrl}/manage-pm/:id/:manageId`}
            component={ManagePM}
          />

          <Route
            exact
            path={`${baseUrl}/rm-tickets/:date?`}
            component={RmTickets}
          />
          <Route
            exact
            path={`${baseUrl}/software-rm-tickets/:date?`}
            component={SoftwareRmTickets}
          />
          <Route
            exact
            path={`${baseUrl}/hardware-rm-tickets/:date?`}
            component={HardwareRmTickets}
          />
          <Route
            exact
            path={`${baseUrl}/rm-tickets-report`}
            component={RmTicketsReport}
          />
          <Route
            exact
            path={[`${baseUrl}/rm-view-details/:id`, `${baseUrl}/rm-view/:id`]}
            component={ViewRmTicket}
          />
          <Route exact path={`${baseUrl}/rm-show/:id`} component={RmView} />
          <Route exact path={`${baseUrl}/rm-log/:id`} component={RmLog} />
          <Route
            exact
            path={`${baseUrl}/complaint-log/:id`}
            component={ComplaintLog}
          />
          <Route
            exact
            path={`${baseUrl}/rm-closed/:status/:id`}
            component={ClosedRmTicket}
          />
          <Route
            exact
            path={[`${baseUrl}/rm-view-report/:id`, `${baseUrl}/rm-view/:id`]}
            component={ViewRmTicketReport}
          />
          <Route
            exact
            path={`${baseUrl}/employee-ticket-list`}
            component={EmployeeTicketList}
          />

          <Route
            exact
            path={`${baseUrl}/rm-assign-ticket/:id`}
            component={RmAssignTicket}
          />
          <Route
            exact
            path={[`${baseUrl}/em-view-details/:id`, `${baseUrl}/em-view/:id`]}
            component={ViewEmployeeTicket}
          />
          <Route
            exact
            path={`${baseUrl}/em-assign-ticket/:id`}
            component={EmTicketAssign}
          />
          <Route
            exact
            path={`${baseUrl}/view-report-pm/:id/:manageId`}
            component={ViewReportPmSites}
          />
          <Route
            exact
            path={`${baseUrl}/site-info/view-checklist/:id/stage/:stageId/:gateId`}
            component={ViewSiteInspectionChecklist}
          />
          <Route
            exact
            path={`${baseUrl}/civil-check/view-checklist/:id/stage/:stageId/:gateId`}
            component={ViewSiteInspectionChecklist}
          />
          <Route
            exact
            path={`${baseUrl}/first-interaction/view-checklist/:id/stage/:stageId/:gateId`}
            component={ViewSiteInspectionChecklist}
          />
          <Route
            exact
            path={`${baseUrl}/configuration-testing/view-checklist/:id/stage/:stageId/:gateId`}
            component={ViewSiteInspectionChecklist}
          />
          <Route
            exact
            path={`${baseUrl}/go_live/view-checklist/:id/stage/:stageId/:gateId`}
            component={ViewSiteInspectionChecklist}
          />
          <Route
            exact
            path={`${baseUrl}/hardware-installation/view-checklist/:id/stage/:stageId/:gateId`}
            component={ViewSiteInspectionChecklist}
          />
          <Route
            exact
            path={`${baseUrl}/handover_checklist/view-checklist/:id/stage/:stageId`}
            component={ViewSiteInspectionChecklist}
          />
          <Route
            exact
            path={`${baseUrl}/mrf/:type/:id/:siteId`}
            component={Mrf}
          />
          <Route
            exact
            path={`${baseUrl}/mrf/:id/:siteId`}
            component={CreateMrf}
          />
          {!role.includes(9) && (
            <Switch>
              <Route
                exact
                path={`${baseUrl}/approvals/rm-tickets/:date?`}
                component={ApprovalRmTickets}
              />
              <Route
                exact
                path={`${baseUrl}/approvals/pm-sites`}
                component={ApprovalPmSites}
              />
              <Route
                exact
                path={`${baseUrl}/approvals/pm-tickets`}
                component={ApprovalPmTicket}
              />
              <Route
                exact
                path={`${baseUrl}/approvals/employee-ticket-list`}
                component={ApprovalEmTicketList}
              />
              {(departmentIds.includes(3) || departmentIds.includes(2)) && (
                <Switch>
                  <Route
                    exact
                    path={`${baseUrl}/ticket-listing`}
                    component={TicketsListing}
                  />
                  <Route
                    exact
                    path={`${baseUrl}/ticket-details/:id`}
                    component={TicketDetails}
                  />
                </Switch>
              )}
              <Route path="*" component={Notfound} />
            </Switch>
          )}
        </Switch>
      )}
      {(activeComponents === "maintenance" || departmentIds.includes(3)) && (
        <Switch>
          <Route
            exact
            path={`${baseUrl}/go-live-site`}
            component={GoLiveSites}
          />
          <Route
            exact
            path={`${baseUrl}/site-listing-maintenance`}
            component={SiteListingMaintenance}
          />
          <Route
            exact
            path={`${baseUrl}/create-pm-list/:id`}
            component={CreatePmList}
          />
          <Route
            exact
            path={`${baseUrl}/pm_checklist/:id`}
            component={PmCheckList}
          />
          <Route exact path={`${baseUrl}/pm-sities`} component={PmSities} />
          <Route
            exact
            path={`${baseUrl}/pm-dashboard`}
            component={PmSitiesDashboard}
          />
          <Route
            exact
            path={`${baseUrl}/view-pm-list/:id/:manageId`}
            component={PmSitesCheckList}
          />

          <Route
            exact
            path={`${baseUrl}/pm-checklist-ques/:id/:manageId/:gateId`}
            component={PmChecklistQues}
          />

          <Route exact path={`${baseUrl}/pm-tickets`} component={PmTickets} />

          <Route
            exact
            path={[
              `${baseUrl}/tickets/view-details/:id`,
              `${baseUrl}/tickets/view/:id`,
            ]}
            component={PMTicketDetails}
          />

          <Route
            exact
            path={`${baseUrl}/assign-ticket/:id`}
            component={PmAssignTicket}
          />

          <Route
            exact
            path={`${baseUrl}/manage-pm/:id/:manageId`}
            component={ManagePM}
          />

          <Route
            exact
            path={`${baseUrl}/rm-tickets/:date?`}
            component={RmTickets}
          />
          <Route
            exact
            path={`${baseUrl}/software-rm-tickets/:date?`}
            component={SoftwareRmTickets}
          />
          <Route
            exact
            path={`${baseUrl}/hardware-rm-tickets/:date?`}
            component={HardwareRmTickets}
          />
          <Route
            exact
            path={`${baseUrl}/rm-tickets-report`}
            component={RmTicketsReport}
          />

          <Route
            exact
            path={[`${baseUrl}/rm-view-details/:id`, `${baseUrl}/rm-view/:id`]}
            component={ViewRmTicket}
          />
          <Route exact path={`${baseUrl}/rm-show/:id`} component={RmView} />
          <Route exact path={`${baseUrl}/rm-log/:id`} component={RmLog} />
          <Route
            exact
            path={`${baseUrl}/complaint-log/:id`}
            component={ComplaintLog}
          />
          <Route
            exact
            path={`${baseUrl}/rm-closed/:status/:id`}
            component={ClosedRmTicket}
          />
          <Route
            exact
            path={[`${baseUrl}/rm-view-report/:id`, `${baseUrl}/rm-view/:id`]}
            component={ViewRmTicketReport}
          />
          <Route
            exact
            path={`${baseUrl}/employee-ticket-list`}
            component={EmployeeTicketList}
          />
          <Route
            exact
            path={`${baseUrl}/rm-tickets/:date?`}
            component={RmTickets}
          />
          <Route
            exact
            path={`${baseUrl}/rm-assign-ticket/:id`}
            component={RmAssignTicket}
          />
          <Route
            exact
            path={[`${baseUrl}/em-view-details/:id`, `${baseUrl}/em-view/:id`]}
            component={ViewEmployeeTicket}
          />
          <Route
            exact
            path={`${baseUrl}/em-assign-ticket/:id`}
            component={EmTicketAssign}
          />
          <Route
            exact
            path={`${baseUrl}/view-report-pm/:id`}
            component={ViewReportPmSites}
          />

          <Route exact path={`${baseUrl}/mrf/:id`} component={Mrf} />
          {!role.includes(9) && (
            <Switch>
              <Route
                exact
                path={`${baseUrl}/approvals/rm-tickets/:date?`}
                component={ApprovalRmTickets}
              />
              <Route
                exact
                path={`${baseUrl}/approvals/pm-sites`}
                component={ApprovalPmSites}
              />
              <Route
                exact
                path={`${baseUrl}/approvals/pm-tickets`}
                component={ApprovalPmTicket}
              />
              <Route
                exact
                path={`${baseUrl}/approvals/employee-ticket-list`}
                component={ApprovalEmTicketList}
              />

              {(departmentIds.includes(3) || departmentIds.includes(2)) && (
                <Switch>
                  <Route
                    exact
                    path={`${baseUrl}/ticket-listing`}
                    component={TicketsListing}
                  />
                  <Route
                    exact
                    path={`${baseUrl}/ticket-details/:id`}
                    component={TicketDetails}
                  />
                </Switch>
              )}

              <Route path="*" component={Notfound} />
            </Switch>
          )}
        </Switch>
      )}
    </Switch>
  );
};

DashboardRoutes.propTypes = {
  baseUrl: PropTypes.string,
};

export default DashboardRoutes;
